//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConfig(): Observable<ClientConfigDto> {
        let url_ = this.baseUrl + "/api/app/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientConfigDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<ClientConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaintenanceMode(): Observable<AppMaintenanceModeDto> {
        let url_ = this.baseUrl + "/api/app/maintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaintenanceMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaintenanceMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppMaintenanceModeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppMaintenanceModeDto>;
        }));
    }

    protected processGetMaintenanceMode(response: HttpResponseBase): Observable<AppMaintenanceModeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppMaintenanceModeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAccess(): Observable<UserAppAccessStatus> {
        let url_ = this.baseUrl + "/api/app/UserAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAppAccessStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAppAccessStatus>;
        }));
    }

    protected processGetUserAccess(response: HttpResponseBase): Observable<UserAppAccessStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAppAccessStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExternalScripts(): Observable<ExternalScriptDto[]> {
        let url_ = this.baseUrl + "/api/app/external-scripts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalScripts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalScripts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalScriptDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalScriptDto[]>;
        }));
    }

    protected processGetExternalScripts(response: HttpResponseBase): Observable<ExternalScriptDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExternalScriptDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettings(): Observable<AppSettingsDto> {
        let url_ = this.baseUrl + "/api/app/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<AppSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrencies(): Observable<AppCurrenciesDto> {
        let url_ = this.baseUrl + "/api/app/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppCurrenciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppCurrenciesDto>;
        }));
    }

    protected processGetCurrencies(response: HttpResponseBase): Observable<AppCurrenciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppCurrenciesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWalkMeParameters(): Observable<AppWalkMeParametersDto> {
        let url_ = this.baseUrl + "/api/app/walk-me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWalkMeParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWalkMeParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppWalkMeParametersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppWalkMeParametersDto>;
        }));
    }

    protected processGetWalkMeParameters(response: HttpResponseBase): Observable<AppWalkMeParametersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppWalkMeParametersDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFeatures(): Observable<UserAppFeaturesDto> {
        let url_ = this.baseUrl + "/api/app/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAppFeaturesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAppFeaturesDto>;
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<UserAppFeaturesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAppFeaturesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVolatileSettings(): Observable<VolatileAppSettingsDto> {
        let url_ = this.baseUrl + "/api/app/volatile-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVolatileSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVolatileSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VolatileAppSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VolatileAppSettingsDto>;
        }));
    }

    protected processGetVolatileSettings(response: HttpResponseBase): Observable<VolatileAppSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolatileAppSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContentAccessApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAccess(type: UserContentType, id: number, context: UserAccessContext | undefined): Observable<UserContentAccessDto> {
        let url_ = this.baseUrl + "/api/content/{type}/{id}/access?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (context === null)
            throw new globalThis.Error("The parameter 'context' cannot be null.");
        else if (context !== undefined)
            url_ += "context=" + encodeURIComponent("" + context) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserContentAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserContentAccessDto>;
        }));
    }

    protected processGetAccess(response: HttpResponseBase): Observable<UserContentAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserContentAccessDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContentSelectorApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listDashboards(library: boolean | undefined, shared: boolean | undefined, samples: boolean | undefined): Observable<ContentSelectorDashboardDto[]> {
        let url_ = this.baseUrl + "/api/content/selector/dashboards?";
        if (library === null)
            throw new globalThis.Error("The parameter 'library' cannot be null.");
        else if (library !== undefined)
            url_ += "library=" + encodeURIComponent("" + library) + "&";
        if (shared === null)
            throw new globalThis.Error("The parameter 'shared' cannot be null.");
        else if (shared !== undefined)
            url_ += "shared=" + encodeURIComponent("" + shared) + "&";
        if (samples === null)
            throw new globalThis.Error("The parameter 'samples' cannot be null.");
        else if (samples !== undefined)
            url_ += "samples=" + encodeURIComponent("" + samples) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentSelectorDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentSelectorDashboardDto[]>;
        }));
    }

    protected processListDashboards(response: HttpResponseBase): Observable<ContentSelectorDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentSelectorDashboardDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listVisuals(library: boolean | undefined, shared: boolean | undefined, samples: boolean | undefined): Observable<ContentSelectorVisualDto[]> {
        let url_ = this.baseUrl + "/api/content/selector/visuals?";
        if (library === null)
            throw new globalThis.Error("The parameter 'library' cannot be null.");
        else if (library !== undefined)
            url_ += "library=" + encodeURIComponent("" + library) + "&";
        if (shared === null)
            throw new globalThis.Error("The parameter 'shared' cannot be null.");
        else if (shared !== undefined)
            url_ += "shared=" + encodeURIComponent("" + shared) + "&";
        if (samples === null)
            throw new globalThis.Error("The parameter 'samples' cannot be null.");
        else if (samples !== undefined)
            url_ += "samples=" + encodeURIComponent("" + samples) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListVisuals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListVisuals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentSelectorVisualDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentSelectorVisualDto[]>;
        }));
    }

    protected processListVisuals(response: HttpResponseBase): Observable<ContentSelectorVisualDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentSelectorVisualDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFileInfo(id: number): Observable<StoredFileInfoDto> {
        let url_ = this.baseUrl + "/api/file/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoredFileInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoredFileInfoDto>;
        }));
    }

    protected processGetFileInfo(response: HttpResponseBase): Observable<StoredFileInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoredFileInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFile(id: number, token: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/file/{id}/download?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileUploadConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Observable<ListFileUploadConfigDto[]> {
        let url_ = this.baseUrl + "/api/file-upload/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListFileUploadConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListFileUploadConfigDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListFileUploadConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListFileUploadConfigDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ItemCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listCategories(): Observable<ListItemCategoryDto[]> {
        let url_ = this.baseUrl + "/api/app/item-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListItemCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListItemCategoryDto[]>;
        }));
    }

    protected processListCategories(response: HttpResponseBase): Observable<ListItemCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItemCategoryDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getState(id: number): Observable<UserJobStateDto> {
        let url_ = this.baseUrl + "/api/job/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserJobStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserJobStateDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<UserJobStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserJobStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancel(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/job/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocaleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getList(): Observable<LocaleDto[]> {
        let url_ = this.baseUrl + "/api/locales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocaleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocaleDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LocaleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocaleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listProducts(): Observable<ListVersionedProductDto[]> {
        let url_ = this.baseUrl + "/api/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListVersionedProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListVersionedProductDto[]>;
        }));
    }

    protected processListProducts(response: HttpResponseBase): Observable<ListVersionedProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListVersionedProductDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductURLs(): Observable<ProductUrlDto[]> {
        let url_ = this.baseUrl + "/api/product/urls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductURLs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductURLs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductUrlDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductUrlDto[]>;
        }));
    }

    protected processGetProductURLs(response: HttpResponseBase): Observable<ProductUrlDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductUrlDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listDashboards(includeFromLibrary: boolean | undefined): Observable<ListUserDashboardDto[]> {
        let url_ = this.baseUrl + "/api/dashboard/list?";
        if (includeFromLibrary === null)
            throw new globalThis.Error("The parameter 'includeFromLibrary' cannot be null.");
        else if (includeFromLibrary !== undefined)
            url_ += "includeFromLibrary=" + encodeURIComponent("" + includeFromLibrary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDashboardDto[]>;
        }));
    }

    protected processListDashboards(response: HttpResponseBase): Observable<ListUserDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDashboardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listWelcomeDashboards(): Observable<ListDashboardDto[]> {
        let url_ = this.baseUrl + "/api/dashboard/welcome/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListWelcomeDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListWelcomeDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardDto[]>;
        }));
    }

    protected processListWelcomeDashboards(response: HttpResponseBase): Observable<ListDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListDashboardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateCheck(check: DashboardDuplicateCheckDto): Observable<DashboardIsDuplicateDto> {
        let url_ = this.baseUrl + "/api/dashboard/name-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(check);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardIsDuplicateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardIsDuplicateDto>;
        }));
    }

    protected processDuplicateCheck(response: HttpResponseBase): Observable<DashboardIsDuplicateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardIsDuplicateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDashboard(addOrUpdateDto: AddOrUpdateDashboardDto): Observable<DashboardDto> {
        let url_ = this.baseUrl + "/api/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDto>;
        }));
    }

    protected processSetDashboard(response: HttpResponseBase): Observable<DashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyDashboard(dashboardId: number): Observable<ListUserDashboardDto> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/copy";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDashboardDto>;
        }));
    }

    protected processCopyDashboard(response: HttpResponseBase): Observable<ListUserDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDashboardDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsage(dashboardId: number): Observable<DashboardUsageDto> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/usage";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardUsageDto>;
        }));
    }

    protected processGetUsage(response: HttpResponseBase): Observable<DashboardUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAsDeleted(dashboardId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/soft-delete";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsDeleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDashboard(dashboardId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/delete";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDashboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFromLibrary(dashboardId: number, fromLibrary: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/library?";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        if (fromLibrary === null)
            throw new globalThis.Error("The parameter 'fromLibrary' cannot be null.");
        else if (fromLibrary !== undefined)
            url_ += "fromLibrary=" + encodeURIComponent("" + fromLibrary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFromLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFromLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetFromLibrary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboard(dashboardId: number): Observable<DashboardDto> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDto>;
        }));
    }

    protected processGetDashboard(response: HttpResponseBase): Observable<DashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardVisuals(dashboardId: number): Observable<DashboardVisualInfoDto[]> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/visuals";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardVisuals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardVisuals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardVisualInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardVisualInfoDto[]>;
        }));
    }

    protected processGetDashboardVisuals(response: HttpResponseBase): Observable<DashboardVisualInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardVisualInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardVisualReconciliationInfo(visualIds: number[]): Observable<DashboardVisualReconciliationInfoDto[]> {
        let url_ = this.baseUrl + "/api/dashboard/visualReconciliationInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(visualIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardVisualReconciliationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardVisualReconciliationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardVisualReconciliationInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardVisualReconciliationInfoDto[]>;
        }));
    }

    protected processGetDashboardVisualReconciliationInfo(response: HttpResponseBase): Observable<DashboardVisualReconciliationInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardVisualReconciliationInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardVisualContent(dashboardId: number): Observable<DashboardVisualContentDto[]> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/visuals/content";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardVisualContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardVisualContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardVisualContentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardVisualContentDto[]>;
        }));
    }

    protected processGetDashboardVisualContent(response: HttpResponseBase): Observable<DashboardVisualContentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardVisualContentDto[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ensureDataAvailable(dashboardId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/datasets/load";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureDataAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureDataAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnsureDataAvailable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDashboardToPdf(dashboardId: number, exportRequest: ExportDashboardToPdfDto): Observable<JobReferenceDto> {
        let url_ = this.baseUrl + "/api/dashboard/{dashboardId}/export/pdf";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDashboardToPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDashboardToPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobReferenceDto>;
        }));
    }

    protected processExportDashboardToPdf(response: HttpResponseBase): Observable<JobReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobReferenceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelFileExport(jobId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dashboard/job/{jobId}/cancel";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelFileExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelFileExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportDashboardToPdfResult(jobId: number): Observable<ExportDashboardToPdfResultDto> {
        let url_ = this.baseUrl + "/api/dashboard/job/{jobId}/result";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportDashboardToPdfResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportDashboardToPdfResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportDashboardToPdfResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportDashboardToPdfResultDto>;
        }));
    }

    protected processGetExportDashboardToPdfResult(response: HttpResponseBase): Observable<ExportDashboardToPdfResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportDashboardToPdfResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    updateUserDashboard(userDashboard: UserDashboardDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDashboard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserDashboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomDatasetService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listDatasetTemplates(productName: string | null | undefined): Observable<AdvancedDatasetDto[]> {
        let url_ = this.baseUrl + "/api/extended-datsets?";
        if (productName !== undefined && productName !== null)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDatasetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDatasetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvancedDatasetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvancedDatasetDto[]>;
        }));
    }

    protected processListDatasetTemplates(response: HttpResponseBase): Observable<AdvancedDatasetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdvancedDatasetDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasetTemplateFields(productName: string | null | undefined, advancedDatasetDto: AdvancedDatasetDto): Observable<AdvancedDatasetFieldDto[]> {
        let url_ = this.baseUrl + "/api/extended-datsets/fields?";
        if (productName !== undefined && productName !== null)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedDatasetDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasetTemplateFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasetTemplateFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvancedDatasetFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvancedDatasetFieldDto[]>;
        }));
    }

    protected processGetDatasetTemplateFields(response: HttpResponseBase): Observable<AdvancedDatasetFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdvancedDatasetFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultJoinFields(): Observable<DatasetDefaultJoinFieldsLookupDto> {
        let url_ = this.baseUrl + "/api/extended-datsets/join-fields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultJoinFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultJoinFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatasetDefaultJoinFieldsLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatasetDefaultJoinFieldsLookupDto>;
        }));
    }

    protected processGetDefaultJoinFields(response: HttpResponseBase): Observable<DatasetDefaultJoinFieldsLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasetDefaultJoinFieldsLookupDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomDatasetDropdownService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listDropdownOptions(getOptionsDto: GetDropdownOptionsDto): Observable<DropdownOptionDto[]> {
        let url_ = this.baseUrl + "/api/extended-datasets/dropdowns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getOptionsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDropdownOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDropdownOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownOptionDto[]>;
        }));
    }

    protected processListDropdownOptions(response: HttpResponseBase): Observable<DropdownOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropdownOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDatasetService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listUserDatasets(): Observable<ListUserDatasetDto[]> {
        let url_ = this.baseUrl + "/api/user/dataset/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUserDatasets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUserDatasets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDatasetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDatasetDto[]>;
        }));
    }

    protected processListUserDatasets(response: HttpResponseBase): Observable<ListUserDatasetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDatasetDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserDataset(id: number, includeContent: boolean | undefined, includeRefreshLog: boolean | undefined): Observable<UserDatasetDto> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeContent === null)
            throw new globalThis.Error("The parameter 'includeContent' cannot be null.");
        else if (includeContent !== undefined)
            url_ += "includeContent=" + encodeURIComponent("" + includeContent) + "&";
        if (includeRefreshLog === null)
            throw new globalThis.Error("The parameter 'includeRefreshLog' cannot be null.");
        else if (includeRefreshLog !== undefined)
            url_ += "includeRefreshLog=" + encodeURIComponent("" + includeRefreshLog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDatasetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDatasetDto>;
        }));
    }

    protected processGetUserDataset(response: HttpResponseBase): Observable<UserDatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDatasetDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateUserDataset(userDatasetDto: AddOrUpdateUserDatasetDto): Observable<ListUserDatasetDto> {
        let url_ = this.baseUrl + "/api/user/dataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDatasetDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDatasetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDatasetDto>;
        }));
    }

    protected processAddOrUpdateUserDataset(response: HttpResponseBase): Observable<ListUserDatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDatasetDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCacheDuration(id: number, cacheDuration: string): Observable<void> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/cache/duration";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cacheDuration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCacheDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCacheDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCacheDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUserDataset(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelRefresh(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/refresh/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelRefresh(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canRefreshUserDataset(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/refresh/check";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanRefreshUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanRefreshUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanRefreshUserDataset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshUserDataset(id: number): Observable<EnsureDataAvailableResult> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/refresh";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnsureDataAvailableResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnsureDataAvailableResult>;
        }));
    }

    protected processRefreshUserDataset(response: HttpResponseBase): Observable<EnsureDataAvailableResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnsureDataAvailableResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCacheStatus(id: number): Observable<UserDatasetRefreshDto> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/cache/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCacheStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCacheStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDatasetRefreshDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDatasetRefreshDto>;
        }));
    }

    protected processGetCacheStatus(response: HttpResponseBase): Observable<UserDatasetRefreshDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDatasetRefreshDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRefreshLog(id: number): Observable<UserDatasetRefreshLogDto> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/refresh/log";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRefreshLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRefreshLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDatasetRefreshLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDatasetRefreshLogDto>;
        }));
    }

    protected processGetRefreshLog(response: HttpResponseBase): Observable<UserDatasetRefreshLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDatasetRefreshLogDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataExpiration(id: number): Observable<string | null> {
        let url_ = this.baseUrl + "/api/user/dataset/{id}/data/expiration";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataExpiration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataExpiration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetDataExpiration(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ensureDataAvailable(userDatasetId: number): Observable<EnsureDataAvailableResult> {
        let url_ = this.baseUrl + "/api/user/dataset/EnsureDataAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDatasetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureDataAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureDataAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnsureDataAvailableResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnsureDataAvailableResult>;
        }));
    }

    protected processEnsureDataAvailable(response: HttpResponseBase): Observable<EnsureDataAvailableResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnsureDataAvailableResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getValidateState(userDatasetId: number): Observable<StoredUserDatasetValidationStateDto> {
        let url_ = this.baseUrl + "/api/user/dataset/{userDatasetId}/validate/state";
        if (userDatasetId === undefined || userDatasetId === null)
            throw new globalThis.Error("The parameter 'userDatasetId' must be defined.");
        url_ = url_.replace("{userDatasetId}", encodeURIComponent("" + userDatasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoredUserDatasetValidationStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoredUserDatasetValidationStateDto>;
        }));
    }

    protected processGetValidateState(response: HttpResponseBase): Observable<StoredUserDatasetValidationStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoredUserDatasetValidationStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validate(userDatasetId: number): Observable<StoredUserDatasetValidationStateDto> {
        let url_ = this.baseUrl + "/api/user/dataset/{userDatasetId}/validate";
        if (userDatasetId === undefined || userDatasetId === null)
            throw new globalThis.Error("The parameter 'userDatasetId' must be defined.");
        url_ = url_.replace("{userDatasetId}", encodeURIComponent("" + userDatasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoredUserDatasetValidationStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoredUserDatasetValidationStateDto>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<StoredUserDatasetValidationStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoredUserDatasetValidationStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setProfiling(userDatasetId: number, profile: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/user/dataset/profile/{userDatasetId}";
        if (userDatasetId === undefined || userDatasetId === null)
            throw new globalThis.Error("The parameter 'userDatasetId' must be defined.");
        url_ = url_.replace("{userDatasetId}", encodeURIComponent("" + userDatasetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProfiling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProfiling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProfiling(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileData(userDatasetId: number, fileType: UserDatasetProfileFileType | undefined, access_token: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/user/dataset/profile/{userDatasetId}/data?";
        if (userDatasetId === undefined || userDatasetId === null)
            throw new globalThis.Error("The parameter 'userDatasetId' must be defined.");
        url_ = url_.replace("{userDatasetId}", encodeURIComponent("" + userDatasetId));
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (access_token !== undefined && access_token !== null)
            url_ += "access_token=" + encodeURIComponent("" + access_token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProfileData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientCustomizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserClientCustomization(): Observable<ClientCustomizationDataDto> {
        let url_ = this.baseUrl + "/api/client-customization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserClientCustomization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserClientCustomization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCustomizationDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCustomizationDataDto>;
        }));
    }

    protected processGetUserClientCustomization(response: HttpResponseBase): Observable<ClientCustomizationDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientCustomizationDataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientCustomizationDataById(organisationId: number): Observable<ClientCustomizationDataDto> {
        let url_ = this.baseUrl + "/api/client-customization/organisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCustomizationDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCustomizationDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCustomizationDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCustomizationDataDto>;
        }));
    }

    protected processGetClientCustomizationDataById(response: HttpResponseBase): Observable<ClientCustomizationDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientCustomizationDataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientCustomizationDataByName(organisationName: string | null | undefined): Observable<ClientCustomizationDataDto> {
        let url_ = this.baseUrl + "/api/client-customization/organisation?";
        if (organisationName !== undefined && organisationName !== null)
            url_ += "organisationName=" + encodeURIComponent("" + organisationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCustomizationDataByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCustomizationDataByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCustomizationDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCustomizationDataDto>;
        }));
    }

    protected processGetClientCustomizationDataByName(response: HttpResponseBase): Observable<ClientCustomizationDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientCustomizationDataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientCustomizationDataByNameLegacy(organisationName: string): Observable<ClientCustomizationDataDto> {
        let url_ = this.baseUrl + "/ClientCustomization/{organisationName}/GetClientCustomizationDataByName";
        if (organisationName === undefined || organisationName === null)
            throw new globalThis.Error("The parameter 'organisationName' must be defined.");
        url_ = url_.replace("{organisationName}", encodeURIComponent("" + organisationName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCustomizationDataByNameLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCustomizationDataByNameLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCustomizationDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCustomizationDataDto>;
        }));
    }

    protected processGetClientCustomizationDataByNameLegacy(response: HttpResponseBase): Observable<ClientCustomizationDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientCustomizationDataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganisationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Observable<ListOrganisationDto[]> {
        let url_ = this.baseUrl + "/api/organisation/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListOrganisationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListOrganisationDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListOrganisationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOrganisationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SpendService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentPeriod(countryId: string | null | undefined): Observable<SpendPeriodDto> {
        let url_ = this.baseUrl + "/spend/period/current?";
        if (countryId !== undefined && countryId !== null)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpendPeriodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpendPeriodDto>;
        }));
    }

    protected processGetCurrentPeriod(response: HttpResponseBase): Observable<SpendPeriodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpendPeriodDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SystemInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSystemInfo(): Observable<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/app/system-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemInfoDto>;
        }));
    }

    protected processGetSystemInfo(response: HttpResponseBase): Observable<SystemInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLicenseInfo(): Observable<LicenseInfoDto> {
        let url_ = this.baseUrl + "/api/app/licenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenseInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenseInfoDto>;
        }));
    }

    protected processGetLicenseInfo(response: HttpResponseBase): Observable<LicenseInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseInfoDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConfig(): Observable<SchedulerConfig> {
        let url_ = this.baseUrl + "/api/schedule/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerConfig>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<SchedulerConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listSchedules(includeShared: boolean | undefined): Observable<ListScheduleDto[]> {
        let url_ = this.baseUrl + "/api/schedule/list?";
        if (includeShared === null)
            throw new globalThis.Error("The parameter 'includeShared' cannot be null.");
        else if (includeShared !== undefined)
            url_ += "includeShared=" + encodeURIComponent("" + includeShared) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListScheduleDto[]>;
        }));
    }

    protected processListSchedules(response: HttpResponseBase): Observable<ListScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListScheduleDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSchedule(schedule: AddOrUpdateScheduleDto): Observable<ScheduleDto> {
        let url_ = this.baseUrl + "/api/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDto>;
        }));
    }

    protected processSetSchedule(response: HttpResponseBase): Observable<ScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateCheck(check: ScheduleDuplicateCheckDto): Observable<ScheduleIsDuplicateDto> {
        let url_ = this.baseUrl + "/api/schedule/name-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(check);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleIsDuplicateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleIsDuplicateDto>;
        }));
    }

    protected processDuplicateCheck(response: HttpResponseBase): Observable<ScheduleIsDuplicateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleIsDuplicateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copySchedule(scheduleId: number): Observable<ScheduleDto> {
        let url_ = this.baseUrl + "/api/schedule/{scheduleId}/copy";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopySchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDto>;
        }));
    }

    protected processCopySchedule(response: HttpResponseBase): Observable<ScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSchedule(scheduleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/schedule/{scheduleId}/delete";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchedule(scheduleId: number): Observable<ScheduleDto> {
        let url_ = this.baseUrl + "/api/schedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleDto>;
        }));
    }

    protected processGetSchedule(response: HttpResponseBase): Observable<ScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextSchedules(schedule: AddOrUpdateScheduleDto): Observable<string[]> {
        let url_ = this.baseUrl + "/api/schedule/next-run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNextSchedules(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    runNowSchedule(scheduleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/schedule/{scheduleId}/run";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunNowSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunNowSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunNowSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadSchedule(scheduleId: number): Observable<ExportDashboardToPdfResultDto> {
        let url_ = this.baseUrl + "/api/schedule/{scheduleId}/download";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportDashboardToPdfResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportDashboardToPdfResultDto>;
        }));
    }

    protected processDownloadSchedule(response: HttpResponseBase): Observable<ExportDashboardToPdfResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportDashboardToPdfResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserScheduleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    updateUserSchedule(userSchedule: UserScheduleDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetLockService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLocks(contentType: string): Observable<AssetLockDto[]> {
        let url_ = this.baseUrl + "/api/asset-lock/{contentType}";
        if (contentType === undefined || contentType === null)
            throw new globalThis.Error("The parameter 'contentType' must be defined.");
        url_ = url_.replace("{contentType}", encodeURIComponent("" + contentType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetLockDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetLockDto[]>;
        }));
    }

    protected processGetLocks(response: HttpResponseBase): Observable<AssetLockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLockDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hasLocks(contentType: string, contentId: number): Observable<AssetLockDto> {
        let url_ = this.baseUrl + "/api/asset-lock/{contentType}/{contentId}";
        if (contentType === undefined || contentType === null)
            throw new globalThis.Error("The parameter 'contentType' must be defined.");
        url_ = url_.replace("{contentType}", encodeURIComponent("" + contentType));
        if (contentId === undefined || contentId === null)
            throw new globalThis.Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasLocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasLocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetLockDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetLockDto>;
        }));
    }

    protected processHasLocks(response: HttpResponseBase): Observable<AssetLockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetLockDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertUserLock(contentType: string, contentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/asset-lock/{contentType}/{contentId}";
        if (contentType === undefined || contentType === null)
            throw new globalThis.Error("The parameter 'contentType' must be defined.");
        url_ = url_.replace("{contentType}", encodeURIComponent("" + contentType));
        if (contentId === undefined || contentId === null)
            throw new globalThis.Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUserLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUserLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertUserLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUserLock(contentType: string, contentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/asset-lock/{contentType}/{contentId}";
        if (contentType === undefined || contentType === null)
            throw new globalThis.Error("The parameter 'contentType' must be defined.");
        url_ = url_.replace("{contentType}", encodeURIComponent("" + contentType));
        if (contentId === undefined || contentId === null)
            throw new globalThis.Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enableUserNotification(contentType: string, contentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/asset-lock/{contentType}/{contentId}/notification";
        if (contentType === undefined || contentType === null)
            throw new globalThis.Error("The parameter 'contentType' must be defined.");
        url_ = url_.replace("{contentType}", encodeURIComponent("" + contentType));
        if (contentId === undefined || contentId === null)
            throw new globalThis.Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableUserNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableUserNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableUserNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BusinessUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getState(): Observable<BusinessUserStateDto> {
        let url_ = this.baseUrl + "/api/business-user/state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUserStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUserStateDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<BusinessUserStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessUserStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putState(stateDto: BusinessUserStateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/business-user/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getNotifications(startDate: string | undefined): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/notifications?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotificationInfo(latestToastIdQuery: number | undefined, startDate: string | undefined, latestToastIdPath: number): Observable<NotificationInfoDto> {
        let url_ = this.baseUrl + "/api/notifications/from/{latestToastId}?";
        if (latestToastIdPath === undefined || latestToastIdPath === null)
            throw new globalThis.Error("The parameter 'latestToastIdPath' must be defined.");
        url_ = url_.replace("{latestToastId}", encodeURIComponent("" + latestToastIdPath));
        if (latestToastIdQuery === null)
            throw new globalThis.Error("The parameter 'latestToastIdQuery' cannot be null.");
        else if (latestToastIdQuery !== undefined)
            url_ += "latestToastId=" + encodeURIComponent("" + latestToastIdQuery) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationInfoDto>;
        }));
    }

    protected processGetNotificationInfo(response: HttpResponseBase): Observable<NotificationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    purgeTimedOutToasts(): Observable<void> {
        let url_ = this.baseUrl + "/api/notifications/purge-timed-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurgeTimedOutToasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurgeTimedOutToasts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPurgeTimedOutToasts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markNotificationToastComplete(id: number, seen: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/notifications/{id}/complete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seen);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationToastComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationToastComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkNotificationToastComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearNotification(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/notifications/{id}/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearActiveNotifications(): Observable<void> {
        let url_ = this.baseUrl + "/api/notifications/clear/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearActiveNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearActiveNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearActiveNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearPendingNotifications(): Observable<void> {
        let url_ = this.baseUrl + "/api/notifications/clear/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearPendingNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearPendingNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearPendingNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPivotExtDatasetLoadNotification(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/{id}/notifications/extended-dataset-load";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPivotExtDatasetLoadNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPivotExtDatasetLoadNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestPivotExtDatasetLoadNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestDashboardExtDatasetLoadNotification(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dashboard/{id}/notifications/extended-dataset-load";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestDashboardExtDatasetLoadNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDashboardExtDatasetLoadNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestDashboardExtDatasetLoadNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRegionRedirectUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/user/region-redirect-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionRedirectUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionRedirectUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRegionRedirectUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(): Observable<AppUserDto> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AppUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClaims(): Observable<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/user/claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string[]; }>;
        }));
    }

    protected processGetClaims(response: HttpResponseBase): Observable<{ [key: string]: string[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string[]; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImpersonatorClaims(): Observable<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/user/impersonation/claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImpersonatorClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImpersonatorClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string[]; }>;
        }));
    }

    protected processGetImpersonatorClaims(response: HttpResponseBase): Observable<{ [key: string]: string[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string[]; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegion(): Observable<string> {
        let url_ = this.baseUrl + "/api/user/region";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersForOrganisation(): Observable<ListUserDto[]> {
        let url_ = this.baseUrl + "/api/user/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForOrganisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForOrganisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDto[]>;
        }));
    }

    protected processGetUsersForOrganisation(response: HttpResponseBase): Observable<ListUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImpersonationTargetUsers(): Observable<ListOrganisationUserDto[]> {
        let url_ = this.baseUrl + "/api/user/impersonation/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImpersonationTargetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImpersonationTargetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListOrganisationUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListOrganisationUserDto[]>;
        }));
    }

    protected processGetImpersonationTargetUsers(response: HttpResponseBase): Observable<ListOrganisationUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOrganisationUserDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserPreferencesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getQueryEditorPreference(): Observable<UserQueryEditorPreferenceDto> {
        let url_ = this.baseUrl + "/api/user/preferences/query-editor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueryEditorPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueryEditorPreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQueryEditorPreferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQueryEditorPreferenceDto>;
        }));
    }

    protected processGetQueryEditorPreference(response: HttpResponseBase): Observable<UserQueryEditorPreferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserQueryEditorPreferenceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setQueryEditorPreference(userQueryEditorPreferencesDto: UserQueryEditorPreferenceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/preferences/query-editor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userQueryEditorPreferencesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetQueryEditorPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetQueryEditorPreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetQueryEditorPreference(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSettingsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    addOrUpdate(preferences: AppSettingsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preferences);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserStateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserState(): Observable<UserStateDto> {
        let url_ = this.baseUrl + "/api/user/state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserStateDto>;
        }));
    }

    protected processGetUserState(response: HttpResponseBase): Observable<UserStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserState(userState: UserStateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userState);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PivotStudioService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConfig(): Observable<PivotStudioConfig> {
        let url_ = this.baseUrl + "/api/pivot-studio/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PivotStudioConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PivotStudioConfig>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<PivotStudioConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PivotStudioConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomFieldFunctions(): Observable<CustomFieldFunction[]> {
        let url_ = this.baseUrl + "/api/pivot-studio/expression-functions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomFieldFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomFieldFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldFunction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldFunction[]>;
        }));
    }

    protected processGetCustomFieldFunctions(response: HttpResponseBase): Observable<CustomFieldFunction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomFieldFunction[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SampleVisualService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setVisualAsSample(visualId: number | undefined, sample: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/sample?";
        if (visualId === null)
            throw new globalThis.Error("The parameter 'visualId' cannot be null.");
        else if (visualId !== undefined)
            url_ += "visualId=" + encodeURIComponent("" + visualId) + "&";
        if (sample === null)
            throw new globalThis.Error("The parameter 'sample' cannot be null.");
        else if (sample !== undefined)
            url_ += "sample=" + encodeURIComponent("" + sample) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetVisualAsSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetVisualAsSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetVisualAsSample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSampleForUser(visualId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/sample/delete?";
        if (visualId === null)
            throw new globalThis.Error("The parameter 'visualId' cannot be null.");
        else if (visualId !== undefined)
            url_ += "visualId=" + encodeURIComponent("" + visualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSampleForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSampleForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSampleForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserVisualService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    updateUserVisual(userVisual: UserVisualDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/visual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userVisual);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserVisual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVisualState(visualId: number): Observable<UserVisualStateDto> {
        let url_ = this.baseUrl + "/api/user/visual/{visualId}/state";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisualState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisualState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVisualStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVisualStateDto>;
        }));
    }

    protected processGetVisualState(response: HttpResponseBase): Observable<UserVisualStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserVisualStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setVisualState(visualId: number, state: UserVisualStateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/user/visual/{visualId}/state";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(state);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetVisualState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetVisualState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetVisualState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VisualService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listVisuals(request: ListItemsForUserRequestDto): Observable<ListUserVisualDto[]> {
        let url_ = this.baseUrl + "/api/visual/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListVisuals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListVisuals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserVisualDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserVisualDto[]>;
        }));
    }

    protected processListVisuals(response: HttpResponseBase): Observable<ListUserVisualDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserVisualDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setVisual(requestDto: SetVisualRequestDto): Observable<VisualDto> {
        let url_ = this.baseUrl + "/api/visual/Set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualDto>;
        }));
    }

    protected processSetVisual(response: HttpResponseBase): Observable<VisualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsage(visualId: number): Observable<VisualUsageDto> {
        let url_ = this.baseUrl + "/api/visual/Usage/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualUsageDto>;
        }));
    }

    protected processGetUsage(response: HttpResponseBase): Observable<VisualUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAsDeleted(visualId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/MarkAsDeleted/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsDeleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVisual(visualId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/Delete/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVisual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVisual(visualId: number, includeDeleted: boolean | undefined): Observable<VisualDto> {
        let url_ = this.baseUrl + "/api/visual/Get/{visualId}?";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualDto>;
        }));
    }

    protected processGetVisual(response: HttpResponseBase): Observable<VisualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModeVisual(visualId: number): Observable<VisualDto> {
        let url_ = this.baseUrl + "/api/visual/GetEditMode/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditModeVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModeVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualDto>;
        }));
    }

    protected processGetEditModeVisual(response: HttpResponseBase): Observable<VisualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelativeDateRange(billingCenter: string | null | undefined, filter: RelativeDateOrTimeValuesDto): Observable<RelativeDateFilterRangeDto> {
        let url_ = this.baseUrl + "/api/visual/GetRelativeDateRange?";
        if (billingCenter !== undefined && billingCenter !== null)
            url_ += "billingCenter=" + encodeURIComponent("" + billingCenter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelativeDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelativeDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeDateFilterRangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeDateFilterRangeDto>;
        }));
    }

    protected processGetRelativeDateRange(response: HttpResponseBase): Observable<RelativeDateFilterRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelativeDateFilterRangeDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyVisual(copyDto: CopyVisualDto): Observable<VisualDto> {
        let url_ = this.baseUrl + "/api/visual/Copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualDto>;
        }));
    }

    protected processCopyVisual(response: HttpResponseBase): Observable<VisualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFromLibrary(visualId: number, fromLibrary: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/visual/SetFromLibrary/{visualId}?";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        if (fromLibrary === null)
            throw new globalThis.Error("The parameter 'fromLibrary' cannot be null.");
        else if (fromLibrary !== undefined)
            url_ += "fromLibrary=" + encodeURIComponent("" + fromLibrary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFromLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFromLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetFromLibrary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImportDetails(file: FileParameter | null | undefined): Observable<ImportVisualDetailsDto> {
        let url_ = this.baseUrl + "/api/visual/GetImportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportVisualDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportVisualDetailsDto>;
        }));
    }

    protected processGetImportDetails(response: HttpResponseBase): Observable<ImportVisualDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportVisualDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importVisual(file: FileParameter | null | undefined, duplicateHandling: string | null | undefined): Observable<ImportVisualResultDto> {
        let url_ = this.baseUrl + "/api/visual/ImportVisual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (duplicateHandling !== null && duplicateHandling !== undefined)
            content_.append("duplicateHandling", duplicateHandling.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportVisualResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportVisualResultDto>;
        }));
    }

    protected processImportVisual(response: HttpResponseBase): Observable<ImportVisualResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportVisualResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDownloadLinks(visualId: number | undefined): Observable<VisualDownloadLinkDto[]> {
        let url_ = this.baseUrl + "/api/visual/GetDownloadLinks?";
        if (visualId === null)
            throw new globalThis.Error("The parameter 'visualId' cannot be null.");
        else if (visualId !== undefined)
            url_ += "visualId=" + encodeURIComponent("" + visualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisualDownloadLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisualDownloadLinkDto[]>;
        }));
    }

    protected processGetDownloadLinks(response: HttpResponseBase): Observable<VisualDownloadLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VisualDownloadLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportData(visualId: number, format: VisualExportDataFormat | undefined, inline: boolean | undefined, forceRefreshCache: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Pivot/ExportData/{visualId}?";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (inline === null)
            throw new globalThis.Error("The parameter 'inline' cannot be null.");
        else if (inline !== undefined)
            url_ += "inline=" + encodeURIComponent("" + inline) + "&";
        if (forceRefreshCache === null)
            throw new globalThis.Error("The parameter 'forceRefreshCache' cannot be null.");
        else if (forceRefreshCache !== undefined)
            url_ += "forceRefreshCache=" + encodeURIComponent("" + forceRefreshCache) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listVisualDatasets(id: number): Observable<ListUserDatasetDto[]> {
        let url_ = this.baseUrl + "/api/visual/{id}/ListVisualDatasets";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListVisualDatasets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListVisualDatasets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDatasetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDatasetDto[]>;
        }));
    }

    protected processListVisualDatasets(response: HttpResponseBase): Observable<ListUserDatasetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDatasetDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setVisualDataset(id: number, datasetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/{id}/SetVisualDataset/{datasetId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (datasetId === undefined || datasetId === null)
            throw new globalThis.Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetVisualDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetVisualDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetVisualDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVisualFromUserDataset(visualId: number, datasetId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/UpdateVisualFromUserDataset/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datasetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVisualFromUserDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVisualFromUserDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateVisualFromUserDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ensureDataAvailable(id: number): Observable<EnsureDataAvailableResult> {
        let url_ = this.baseUrl + "/api/visual/EnsureDataAvailable/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureDataAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureDataAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnsureDataAvailableResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnsureDataAvailableResult>;
        }));
    }

    protected processEnsureDataAvailable(response: HttpResponseBase): Observable<EnsureDataAvailableResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnsureDataAvailableResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportVisualDefinition(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/visual/ExportVisualDefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVisualDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVisualDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportVisualDefinition(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importVisualDefinitions(files: FileParameter[] | null | undefined): Observable<DiagnosticCollectionDto> {
        let url_ = this.baseUrl + "/api/visual/ImportVisualDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportVisualDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportVisualDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagnosticCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagnosticCollectionDto>;
        }));
    }

    protected processImportVisualDefinitions(response: HttpResponseBase): Observable<DiagnosticCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiagnosticCollectionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    expireCache(visualId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/ExpireCache/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExpireCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUntitledVisualName(): Observable<string> {
        let url_ = this.baseUrl + "/api/visual/GetUntitledVisualName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUntitledVisualName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUntitledVisualName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUntitledVisualName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VisualExportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportFile(exportDto: ExportVisualFileRequestDto): Observable<JobReferenceDto> {
        let url_ = this.baseUrl + "/api/visual/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobReferenceDto>;
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<JobReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobReferenceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelFileExport(jobId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/visual/export/job/{jobId}/cancel";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelFileExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelFileExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportStatus(jobId: number): Observable<ExportVisualDataStatusDto> {
        let url_ = this.baseUrl + "/api/visual/export/job/{jobId}/state";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportVisualDataStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportVisualDataStatusDto>;
        }));
    }

    protected processGetExportStatus(response: HttpResponseBase): Observable<ExportVisualDataStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportVisualDataStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportResult(jobId: number): Observable<ExportVisualDataResultDto> {
        let url_ = this.baseUrl + "/api/visual/export/job/{jobId}/result";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportVisualDataResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportVisualDataResultDto>;
        }));
    }

    protected processGetExportResult(response: HttpResponseBase): Observable<ExportVisualDataResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportVisualDataResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataModelAdminApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProductVersionDataModel(versionId: number): Observable<DataModelDto> {
        let url_ = this.baseUrl + "/api/admin/data-model/product-version/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVersionDataModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVersionDataModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelDto>;
        }));
    }

    protected processGetProductVersionDataModel(response: HttpResponseBase): Observable<DataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putProductVersionDataModel(versionId: number, dataModelDto: DataModelDto): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/data-model/product-version/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataModelDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutProductVersionDataModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutProductVersionDataModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutProductVersionDataModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrganisationDataModel(organisationId: number): Observable<DataModelDto> {
        let url_ = this.baseUrl + "/api/admin/data-model/organisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationDataModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationDataModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelDto>;
        }));
    }

    protected processGetOrganisationDataModel(response: HttpResponseBase): Observable<DataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataModelUserApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOrganisationDataModel(organisationId: number, ifNoneMatch: string | null | undefined): Observable<OrganisationDataModelDto> {
        let url_ = this.baseUrl + "/api/data-model/organisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "If-None-Match": ifNoneMatch !== undefined && ifNoneMatch !== null ? "" + ifNoneMatch : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationDataModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationDataModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationDataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationDataModelDto>;
        }));
    }

    protected processGetOrganisationDataModel(response: HttpResponseBase): Observable<OrganisationDataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDataModelDto;
            return _observableOf(result200);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserDatasetDataModel(organisationId: number, userDatasetId: number, ifNoneMatch: string | null | undefined): Observable<OrganisationDataModelDto> {
        let url_ = this.baseUrl + "/api/data-model/organisation/{organisationId}/user-dataset/{userDatasetId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (userDatasetId === undefined || userDatasetId === null)
            throw new globalThis.Error("The parameter 'userDatasetId' must be defined.");
        url_ = url_.replace("{userDatasetId}", encodeURIComponent("" + userDatasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "If-None-Match": ifNoneMatch !== undefined && ifNoneMatch !== null ? "" + ifNoneMatch : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDatasetDataModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDatasetDataModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationDataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationDataModelDto>;
        }));
    }

    protected processGetUserDatasetDataModel(response: HttpResponseBase): Observable<OrganisationDataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDataModelDto;
            return _observableOf(result200);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataRelationshipMappingUserApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOrganisationDataModelRelationshipMapping(organisationId: number, ifNoneMatch: string | null | undefined): Observable<DataRelationshipMappingDto> {
        let url_ = this.baseUrl + "/api/data-model/organisation/{organisationId}/relationship-mapping";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "If-None-Match": ifNoneMatch !== undefined && ifNoneMatch !== null ? "" + ifNoneMatch : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationDataModelRelationshipMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationDataModelRelationshipMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataRelationshipMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataRelationshipMappingDto>;
        }));
    }

    protected processGetOrganisationDataModelRelationshipMapping(response: HttpResponseBase): Observable<DataRelationshipMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataRelationshipMappingDto;
            return _observableOf(result200);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EnterpriseUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(searchTerm: string | null | undefined, maxRows: number | null | undefined): Observable<ListEnterpriseUserDto[]> {
        let url_ = this.baseUrl + "/api/enterprise-user/list?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (maxRows !== undefined && maxRows !== null)
            url_ += "MaxRows=" + encodeURIComponent("" + maxRows) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListEnterpriseUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListEnterpriseUserDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListEnterpriseUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListEnterpriseUserDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getData(): Observable<EnterpriseUserDataDto> {
        let url_ = this.baseUrl + "/api/enterprise-user/data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnterpriseUserDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnterpriseUserDataDto>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<EnterpriseUserDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnterpriseUserDataDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataForUser(userName: string | null | undefined): Observable<EnterpriseUserDataDto> {
        let url_ = this.baseUrl + "/api/enterprise-user/data/find?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnterpriseUserDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnterpriseUserDataDto>;
        }));
    }

    protected processGetDataForUser(response: HttpResponseBase): Observable<EnterpriseUserDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnterpriseUserDataDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublishedReportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Observable<ListPublishedReportDto[]> {
        let url_ = this.baseUrl + "/api/published-report/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListPublishedReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListPublishedReportDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListPublishedReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListPublishedReportDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listForBusinessUser(): Observable<ListPublishedReportForBusinessUserDto[]> {
        let url_ = this.baseUrl + "/api/published-report/business-user/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListForBusinessUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListForBusinessUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListPublishedReportForBusinessUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListPublishedReportForBusinessUserDto[]>;
        }));
    }

    protected processListForBusinessUser(response: HttpResponseBase): Observable<ListPublishedReportForBusinessUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListPublishedReportForBusinessUserDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(publishedReportId: number): Observable<PublishedReportDto> {
        let url_ = this.baseUrl + "/api/published-report/{publishedReportId}";
        if (publishedReportId === undefined || publishedReportId === null)
            throw new globalThis.Error("The parameter 'publishedReportId' must be defined.");
        url_ = url_.replace("{publishedReportId}", encodeURIComponent("" + publishedReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublishedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublishedReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PublishedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishedReportDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(publishedReportId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/published-report/{publishedReportId}";
        if (publishedReportId === undefined || publishedReportId === null)
            throw new globalThis.Error("The parameter 'publishedReportId' must be defined.");
        url_ = url_.replace("{publishedReportId}", encodeURIComponent("" + publishedReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdate(addOrUpdateDto: AddOrUpdatePublishedReportDto): Observable<number> {
        let url_ = this.baseUrl + "/api/published-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateCheck(checkDto: PublishedReportDuplicateCheckDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/published-report/name-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDuplicateCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(publishedReportId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/published-report/{publishedReportId}/copy";
        if (publishedReportId === undefined || publishedReportId === null)
            throw new globalThis.Error("The parameter 'publishedReportId' must be defined.");
        url_ = url_.replace("{publishedReportId}", encodeURIComponent("" + publishedReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listUserStates(): Observable<UserPublishedReportStateDto[]> {
        let url_ = this.baseUrl + "/api/published-report/user-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUserStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUserStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPublishedReportStateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPublishedReportStateDto[]>;
        }));
    }

    protected processListUserStates(response: HttpResponseBase): Observable<UserPublishedReportStateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPublishedReportStateDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserState(stateDto: UserPublishedReportStateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/published-report/user-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setIsDefault(stateDto: SetPublishedReportIsDefaultDto): Observable<void> {
        let url_ = this.baseUrl + "/api/published-report/defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetIsDefault(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultState(publishedReportId: number): Observable<DefaultPublishedReportStateDto> {
        let url_ = this.baseUrl + "/api/published-report/defaults/{publishedReportId}";
        if (publishedReportId === undefined || publishedReportId === null)
            throw new globalThis.Error("The parameter 'publishedReportId' must be defined.");
        url_ = url_.replace("{publishedReportId}", encodeURIComponent("" + publishedReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultPublishedReportStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultPublishedReportStateDto>;
        }));
    }

    protected processGetDefaultState(response: HttpResponseBase): Observable<DefaultPublishedReportStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefaultPublishedReportStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDefaultState(stateDto: DefaultPublishedReportStateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/published-report/defaults/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataQueryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    executeQuery(request: ExecuteDataQueryRequest): Observable<ExecuteDataQueryResponse> {
        let url_ = this.baseUrl + "/api/dataquery/query/execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecuteDataQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecuteDataQueryResponse>;
        }));
    }

    protected processExecuteQuery(response: HttpResponseBase): Observable<ExecuteDataQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExecuteDataQueryResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeStreamedQuery(request: ExecuteDataQueryRequest): Observable<StreamedExecuteDataQueryRequest> {
        let url_ = this.baseUrl + "/api/dataquery/query/execute/stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteStreamedQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteStreamedQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StreamedExecuteDataQueryRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StreamedExecuteDataQueryRequest>;
        }));
    }

    protected processExecuteStreamedQuery(response: HttpResponseBase): Observable<StreamedExecuteDataQueryRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StreamedExecuteDataQueryRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelQuery(request: CancelQueryRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/dataquery/query/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelQuery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQueryState(request: GetQueryStateRequest): Observable<GetQueryStateResponse> {
        let url_ = this.baseUrl + "/api/dataquery/query/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueryState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueryState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQueryStateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQueryStateResponse>;
        }));
    }

    protected processGetQueryState(response: HttpResponseBase): Observable<GetQueryStateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetQueryStateResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQueryResult(request: GetQueryResultRequest): Observable<GetQueryResultResponse> {
        let url_ = this.baseUrl + "/api/dataquery/query/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueryResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueryResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQueryResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQueryResultResponse>;
        }));
    }

    protected processGetQueryResult(response: HttpResponseBase): Observable<GetQueryResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetQueryResultResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResultSetDataUrl(request: GetResultSetDataUrlRequest): Observable<GetResultSetDataUrlResponse> {
        let url_ = this.baseUrl + "/api/dataquery/resultset/data/url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultSetDataUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultSetDataUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultSetDataUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultSetDataUrlResponse>;
        }));
    }

    protected processGetResultSetDataUrl(response: HttpResponseBase): Observable<GetResultSetDataUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetResultSetDataUrlResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeStreamedResultSetQuery(request: ResultSetDataQueryRequest): Observable<StreamedResultSetDataQueryRequest> {
        let url_ = this.baseUrl + "/api/dataquery/resultset/execute/stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteStreamedResultSetQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteStreamedResultSetQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StreamedResultSetDataQueryRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StreamedResultSetDataQueryRequest>;
        }));
    }

    protected processExecuteStreamedResultSetQuery(response: HttpResponseBase): Observable<StreamedResultSetDataQueryRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StreamedResultSetDataQueryRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isQueryValid(queryId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/dataquery/query/{queryId}/valid";
        if (queryId === undefined || queryId === null)
            throw new globalThis.Error("The parameter 'queryId' must be defined.");
        url_ = url_.replace("{queryId}", encodeURIComponent("" + queryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsQueryValid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsQueryValid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsQueryValid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQueryPlan(request: GetQueryPlanRequest): Observable<GetQueryPlanResponse> {
        let url_ = this.baseUrl + "/api/dataquery/query/plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQueryPlanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQueryPlanResponse>;
        }));
    }

    protected processGetQueryPlan(response: HttpResponseBase): Observable<GetQueryPlanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetQueryPlanResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AIAgentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createSession(request: AIAgentSessionCreateRequest): Observable<AIAgentSession> {
        let url_ = this.baseUrl + "/api/ai/agent/session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSession>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSession>;
        }));
    }

    protected processCreateSession(response: HttpResponseBase): Observable<AIAgentSession> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSession;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSessions(includeCompleted: boolean | undefined, includeHidden: boolean | undefined): Observable<AIAgentSession[]> {
        let url_ = this.baseUrl + "/api/ai/agent/session?";
        if (includeCompleted === null)
            throw new globalThis.Error("The parameter 'includeCompleted' cannot be null.");
        else if (includeCompleted !== undefined)
            url_ += "includeCompleted=" + encodeURIComponent("" + includeCompleted) + "&";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "includeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSession[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSession[]>;
        }));
    }

    protected processGetSessions(response: HttpResponseBase): Observable<AIAgentSession[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSession[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSession(id: number): Observable<AIAgentSession> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSession>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSession>;
        }));
    }

    protected processGetSession(response: HttpResponseBase): Observable<AIAgentSession> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSession;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSessionMessages(after: number | null | undefined, id: number): Observable<AIAgentSessionMessage[]> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}/messages?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSessionMessage[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSessionMessage[]>;
        }));
    }

    protected processGetSessionMessages(response: HttpResponseBase): Observable<AIAgentSessionMessage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSessionMessage[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelSession(id: number): Observable<AIAgentSession[]> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSession[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSession[]>;
        }));
    }

    protected processCancelSession(response: HttpResponseBase): Observable<AIAgentSession[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSession[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hideSession(id: number): Observable<AIAgentSession[]> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}/hide";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHideSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHideSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSession[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSession[]>;
        }));
    }

    protected processHideSession(response: HttpResponseBase): Observable<AIAgentSession[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSession[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUserPromptToSession(id: number, messageContent: string): Observable<AIAgentExecuteModel> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}/user-prompt";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageContent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserPromptToSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserPromptToSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentExecuteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentExecuteModel>;
        }));
    }

    protected processAddUserPromptToSession(response: HttpResponseBase): Observable<AIAgentExecuteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentExecuteModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    next(id: number, nextModel: AIAgentExecuteModel): Observable<AIAgentSessionMessage[]> {
        let url_ = this.baseUrl + "/api/ai/agent/session/{id}/next";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nextModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIAgentSessionMessage[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIAgentSessionMessage[]>;
        }));
    }

    protected processNext(response: HttpResponseBase): Observable<AIAgentSessionMessage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AIAgentSessionMessage[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminCacheService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEntries(filter: string | null | undefined): Observable<CacheEntryDto[]> {
        let url_ = this.baseUrl + "/api/admin/cache/entries?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CacheEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CacheEntryDto[]>;
        }));
    }

    protected processGetEntries(response: HttpResponseBase): Observable<CacheEntryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CacheEntryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/cache/clear/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearKeys(keys: ClearCacheKeysDto): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/cache/clear/keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearKeys(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminClientCustomizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setClientCustomization(organisationId: number, applyContentExport: boolean | undefined, applyEmail: boolean | undefined, font: string | null | undefined, removeLogo: boolean | undefined, logoFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ClientCustomization/{organisationId}/SetClientCustomization";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (applyContentExport === null || applyContentExport === undefined)
            throw new globalThis.Error("The parameter 'applyContentExport' cannot be null.");
        else
            content_.append("ApplyContentExport", applyContentExport.toString());
        if (applyEmail === null || applyEmail === undefined)
            throw new globalThis.Error("The parameter 'applyEmail' cannot be null.");
        else
            content_.append("ApplyEmail", applyEmail.toString());
        if (font !== null && font !== undefined)
            content_.append("Font", font.toString());
        if (removeLogo === null || removeLogo === undefined)
            throw new globalThis.Error("The parameter 'removeLogo' cannot be null.");
        else
            content_.append("RemoveLogo", removeLogo.toString());
        if (logoFile !== null && logoFile !== undefined)
            content_.append("logoFile", logoFile.data, logoFile.fileName ? logoFile.fileName : "logoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetClientCustomization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetClientCustomization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetClientCustomization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientCustomizationSettings(organisationId: number): Observable<ClientCustomizationSettingsDto> {
        let url_ = this.baseUrl + "/api/Admin/ClientCustomization/{organisationId}/GetClientCustomizationSettings";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCustomizationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCustomizationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCustomizationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCustomizationSettingsDto>;
        }));
    }

    protected processGetClientCustomizationSettings(response: HttpResponseBase): Observable<ClientCustomizationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientCustomizationSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPreviewEmail(organisationId: number, recipient: string | null | undefined, font: string | null | undefined, useExistingLogo: boolean | undefined, useLogo: boolean | undefined, logoFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ClientCustomization/{organisationId}/SendPreview";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (recipient !== null && recipient !== undefined)
            content_.append("Recipient", recipient.toString());
        if (font !== null && font !== undefined)
            content_.append("Font", font.toString());
        if (useExistingLogo === null || useExistingLogo === undefined)
            throw new globalThis.Error("The parameter 'useExistingLogo' cannot be null.");
        else
            content_.append("UseExistingLogo", useExistingLogo.toString());
        if (useLogo === null || useLogo === undefined)
            throw new globalThis.Error("The parameter 'useLogo' cannot be null.");
        else
            content_.append("UseLogo", useLogo.toString());
        if (logoFile !== null && logoFile !== undefined)
            content_.append("logoFile", logoFile.data, logoFile.fileName ? logoFile.fileName : "logoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPreviewEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPreviewEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPreviewEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    clearMemoryCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ClearMemoryCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearMemoryCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearMemoryCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearMemoryCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppFeatures(): Observable<AppFeaturesDto> {
        let url_ = this.baseUrl + "/api/Admin/GetAppFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppFeaturesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppFeaturesDto>;
        }));
    }

    protected processGetAppFeatures(response: HttpResponseBase): Observable<AppFeaturesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeaturesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAppFeatures(featuresDto: AppFeaturesDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/SetAppFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(featuresDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAppFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAppFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAppFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrganisationAppFeatures(organisationId: number): Observable<AppFeaturesSettings> {
        let url_ = this.baseUrl + "/api/Admin/GetAppFeatures/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationAppFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationAppFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppFeaturesSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppFeaturesSettings>;
        }));
    }

    protected processGetOrganisationAppFeatures(response: HttpResponseBase): Observable<AppFeaturesSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppFeaturesSettings;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setOrganisationAppFeatures(organisationId: number, settings: AppFeaturesSettings): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/SetAppFeatures/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrganisationAppFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrganisationAppFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetOrganisationAppFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    runProductUpgradeChecks(): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/RunProductUpgradeChecks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunProductUpgradeChecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunProductUpgradeChecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunProductUpgradeChecks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setMaintenanceMode(maintenanceModeDto: AppMaintenanceModeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/SetMaintenanceMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintenanceModeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMaintenanceMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMaintenanceMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetMaintenanceMode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    runDataQueryModelCleanup(): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/RunDataQueryModelCleanup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDataQueryModelCleanup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDataQueryModelCleanup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunDataQueryModelCleanup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listWelcomeDashboards(organisationId: number): Observable<ListDashboardDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/ListWelcomeDashboards/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListWelcomeDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListWelcomeDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardDto[]>;
        }));
    }

    protected processListWelcomeDashboards(response: HttpResponseBase): Observable<ListDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListDashboardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setWelcomeDashboards(setWelcomeDashboardsDto: SetWelcomeDashboardsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/SetWelcomeDashboards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setWelcomeDashboardsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetWelcomeDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetWelcomeDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetWelcomeDashboards(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardWelcomeScreens(dashboardId: number): Observable<DashboardWelcomeScreensDto> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/GetDashboardWelcomeScreens/{dashboardId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardWelcomeScreens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardWelcomeScreens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWelcomeScreensDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWelcomeScreensDto>;
        }));
    }

    protected processGetDashboardWelcomeScreens(response: HttpResponseBase): Observable<DashboardWelcomeScreensDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardWelcomeScreensDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDashboardWelcomeScreens(welcomeScreensDto: DashboardWelcomeScreensDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/SetDashboardWelcomeScreens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(welcomeScreensDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDashboardWelcomeScreens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDashboardWelcomeScreens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDashboardWelcomeScreens(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDashboardsExportImportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listDashboards(): Observable<ListDashboardDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/ListExportable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardDto[]>;
        }));
    }

    protected processListDashboards(response: HttpResponseBase): Observable<ListDashboardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListDashboardDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDashboard(dashboardId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/ExportDashboard/{dashboardId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDashboard(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDashboard(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Dashboards/ImportDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportDashboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDataModelService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    toFile(fileName: string | null | undefined, modelDto: DataModelDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/DataModel/ToFile?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processToFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fromFile(file: FileParameter | null | undefined): Observable<DataModelDto> {
        let url_ = this.baseUrl + "/api/Admin/DataModel/FromFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelDto>;
        }));
    }

    protected processFromFile(response: HttpResponseBase): Observable<DataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDataRelationshipMappingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMapping(): Observable<DataRelationshipMappingDto> {
        let url_ = this.baseUrl + "/api/Admin/AdminDataRelationshipMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataRelationshipMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataRelationshipMappingDto>;
        }));
    }

    protected processGetMapping(response: HttpResponseBase): Observable<DataRelationshipMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataRelationshipMappingDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setMapping(mappingDto: DataRelationshipMappingDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/AdminDataRelationshipMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mappingDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetMapping(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download(fileName: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/AdminDataRelationshipMapping/download?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/AdminDataRelationshipMapping/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminETLStatusService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Observable<ListETLStatusDto[]> {
        let url_ = this.baseUrl + "/api/Admin/EtlStatus/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListETLStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListETLStatusDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListETLStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListETLStatusDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminExtendedDatasetManagerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    importExtendedDatasetTemplate(versionId: number, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Datasets/{versionId}/Import";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExtendedDatasetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExtendedDatasetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportExtendedDatasetTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listExtendedDatasetTemplates(versionId: number): Observable<ExtendedDatasetListItemDto[]> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Datasets/{versionId}/List";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListExtendedDatasetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListExtendedDatasetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedDatasetListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedDatasetListItemDto[]>;
        }));
    }

    protected processListExtendedDatasetTemplates(response: HttpResponseBase): Observable<ExtendedDatasetListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedDatasetListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAdvancedDatasets(versionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Datasets/{versionId}/Export";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAdvancedDatasets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAdvancedDatasets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportAdvancedDatasets(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataset(versionId: number, name: string): Observable<ExtendedDatasetTemplateDto> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Datasets/{versionId}/{name}/Get";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedDatasetTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedDatasetTemplateDto>;
        }));
    }

    protected processGetDataset(response: HttpResponseBase): Observable<ExtendedDatasetTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedDatasetTemplateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDataset(versionId: number, name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Datasets/{versionId}/{name}/Export";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDataset(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDataset(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dataset/{id}/Delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDatasetsInVersion(versionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dataset/{versionId}/DeleteAll";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDatasetsInVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDatasetsInVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDatasetsInVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDataset(id: number, request: ExtendedDatasetTemplateUpdateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dataset/{id}/Update";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importExtendedDatasetDropdowns(versionId: number, files: FileParameter[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/Import";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExtendedDatasetDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExtendedDatasetDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processImportExtendedDatasetDropdowns(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listExtendedDatasetDropdowns(versionId: number): Observable<ExtendedDatasetDropdownListItemDto[]> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/List";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListExtendedDatasetDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListExtendedDatasetDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedDatasetDropdownListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedDatasetDropdownListItemDto[]>;
        }));
    }

    protected processListExtendedDatasetDropdowns(response: HttpResponseBase): Observable<ExtendedDatasetDropdownListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedDatasetDropdownListItemDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDropdowns(versionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/Export";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDropdowns(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDropdown(versionId: number, name: string): Observable<ExtendedDatasetDropdownDto> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/{name}/Get";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedDatasetDropdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedDatasetDropdownDto>;
        }));
    }

    protected processGetDropdown(response: HttpResponseBase): Observable<ExtendedDatasetDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedDatasetDropdownDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDropdown(versionId: number, name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/{name}/Export";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDropdown(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDropdown(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{id}/Delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDropdown(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDropdownsInVersion(versionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdowns/{versionId}/DeleteAll";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDropdownsInVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDropdownsInVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDropdownsInVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDropdown(id: number, request: ExtendedDatasetDropdownUpdateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdown/{id}/Update";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDropdown(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDataset(item: ExtendedDatasetListItemDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dataset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDataset(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDropdown(item: ExtendedDatasetDropdownListItemDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/ExtendedDatasetManager/Dropdown/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDropdown(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminFileUploadConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(organisationId: number): Observable<ListFileUploadConfigDto[]> {
        let url_ = this.baseUrl + "/api/Admin/FileUploadConfig/{organisationId}/List";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListFileUploadConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListFileUploadConfigDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListFileUploadConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListFileUploadConfigDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<FileUploadConfigDto> {
        let url_ = this.baseUrl + "/api/Admin/FileUploadConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadConfigDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileUploadConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadConfigDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/FileUploadConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdate(addOrUpdateDto: AddOrUpdateFileUploadConfigDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/FileUploadConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testConnection(id: number): Observable<FileUploadVerifyConnectionResultDto> {
        let url_ = this.baseUrl + "/api/Admin/FileUploadConfig/{id}/TestConnection";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadVerifyConnectionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadVerifyConnectionResultDto>;
        }));
    }

    protected processTestConnection(response: HttpResponseBase): Observable<FileUploadVerifyConnectionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadVerifyConnectionResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminGainsightPXService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSettings(): Observable<GainsightPXSettings> {
        let url_ = this.baseUrl + "/api/Admin/GainsightPX/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GainsightPXSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GainsightPXSettings>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<GainsightPXSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GainsightPXSettings;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSettings(settings: GainsightPXSettings): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/GainsightPX/Settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminJobInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/ListIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processListIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    list(query: JobInfoQueryDto | undefined): Observable<JobInfoDto[]> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobInfoDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<JobInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrackedJobsInfo(request: GetTrackedJobInfoRequestDto): Observable<GetTrackedJobInfoResultDto> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/GetTrackedJobsInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrackedJobsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrackedJobsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrackedJobInfoResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrackedJobInfoResultDto>;
        }));
    }

    protected processGetTrackedJobsInfo(response: HttpResponseBase): Observable<GetTrackedJobInfoResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTrackedJobInfoResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/GetJobTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetJobTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelJob(jobId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/CancelJob/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setJobDisabledValue(jobId: number, disabled: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/SetJobDisabledValue/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(disabled);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetJobDisabledValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetJobDisabledValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetJobDisabledValue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateJob(jobId: number, modificationDto: JobModificationDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/DuplicateJob/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modificationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDuplicateJob(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editJob(jobId: number, modificationDto: JobModificationDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/EditJob/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modificationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEditJob(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobData(jobId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/Admin/JobInfo/GetJobData/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJobData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminOrganisationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Observable<ListOrganisationDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListOrganisationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListOrganisationDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListOrganisationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOrganisationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<OrganisationDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganisationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdate(organisation: AddOrUpdateOrganisationDto): Observable<OrganisationDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationDto>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<OrganisationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<OrganisationDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationDto>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<OrganisationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    performUpgradeCheck(id: number): Observable<JobReferenceDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/PerformUpgradeCheck/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformUpgradeCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformUpgradeCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobReferenceDto>;
        }));
    }

    protected processPerformUpgradeCheck(response: HttpResponseBase): Observable<JobReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobReferenceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateCombinedDataset(id: number, skipLoad: boolean | undefined, skipCombine: boolean | undefined, skipIndexes: boolean | undefined, doNotParallelize: boolean | undefined): Observable<JobReferenceDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/GenerateCombinedDataset/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skipLoad === null)
            throw new globalThis.Error("The parameter 'skipLoad' cannot be null.");
        else if (skipLoad !== undefined)
            url_ += "skipLoad=" + encodeURIComponent("" + skipLoad) + "&";
        if (skipCombine === null)
            throw new globalThis.Error("The parameter 'skipCombine' cannot be null.");
        else if (skipCombine !== undefined)
            url_ += "skipCombine=" + encodeURIComponent("" + skipCombine) + "&";
        if (skipIndexes === null)
            throw new globalThis.Error("The parameter 'skipIndexes' cannot be null.");
        else if (skipIndexes !== undefined)
            url_ += "skipIndexes=" + encodeURIComponent("" + skipIndexes) + "&";
        if (doNotParallelize === null)
            throw new globalThis.Error("The parameter 'doNotParallelize' cannot be null.");
        else if (doNotParallelize !== undefined)
            url_ += "doNotParallelize=" + encodeURIComponent("" + doNotParallelize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCombinedDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCombinedDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobReferenceDto>;
        }));
    }

    protected processGenerateCombinedDataset(response: HttpResponseBase): Observable<JobReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobReferenceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLastJobId(organisationId: number): Observable<JobStateDto> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/GetLastJobId/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobStateDto>;
        }));
    }

    protected processGetLastJobId(response: HttpResponseBase): Observable<JobStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLastJobIds(): Observable<GetLastJobIdDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/GetLastJobIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastJobIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastJobIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLastJobIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLastJobIdDto[]>;
        }));
    }

    protected processGetLastJobIds(response: HttpResponseBase): Observable<GetLastJobIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLastJobIdDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTestEmail(organisationId: number, request: SendTestEmailRequestDto): Observable<ErrorDto> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/send-test-email";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorDto>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<ErrorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshModel(organisationId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/model/refresh";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModelRefreshLogs(afterTimestamp: string | null | undefined, organisationId: number): Observable<DataModelRefreshLog[]> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/model/refresh/logs?";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (afterTimestamp !== undefined && afterTimestamp !== null)
            url_ += "afterTimestamp=" + encodeURIComponent("" + afterTimestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModelRefreshLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModelRefreshLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelRefreshLog[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelRefreshLog[]>;
        }));
    }

    protected processGetModelRefreshLogs(response: HttpResponseBase): Observable<DataModelRefreshLog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelRefreshLog[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateCombinedDatasetDirect(id: number, skipLoad: boolean | undefined, skipCombine: boolean | undefined, skipIndexes: boolean | undefined, doNotParallelize: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/GenerateCombinedDatasetDirect/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skipLoad === null)
            throw new globalThis.Error("The parameter 'skipLoad' cannot be null.");
        else if (skipLoad !== undefined)
            url_ += "skipLoad=" + encodeURIComponent("" + skipLoad) + "&";
        if (skipCombine === null)
            throw new globalThis.Error("The parameter 'skipCombine' cannot be null.");
        else if (skipCombine !== undefined)
            url_ += "skipCombine=" + encodeURIComponent("" + skipCombine) + "&";
        if (skipIndexes === null)
            throw new globalThis.Error("The parameter 'skipIndexes' cannot be null.");
        else if (skipIndexes !== undefined)
            url_ += "skipIndexes=" + encodeURIComponent("" + skipIndexes) + "&";
        if (doNotParallelize === null)
            throw new globalThis.Error("The parameter 'doNotParallelize' cannot be null.");
        else if (doNotParallelize !== undefined)
            url_ += "doNotParallelize=" + encodeURIComponent("" + doNotParallelize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCombinedDatasetDirect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCombinedDatasetDirect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateCombinedDatasetDirect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    eTLCheck(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/ETLCheck/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processETLCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processETLCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processETLCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductSources(organisationId: number): Observable<OrganisationProductConnectionDetails[]> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/product/sources";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationProductConnectionDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationProductConnectionDetails[]>;
        }));
    }

    protected processGetProductSources(response: HttpResponseBase): Observable<OrganisationProductConnectionDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationProductConnectionDetails[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    productSourceExecuteSql(organisationId: number, request: ProductSourceExecuteSqlRequest): Observable<ProductSourceExecuteSqlResponse> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/product/sources/executeSql";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductSourceExecuteSql(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductSourceExecuteSql(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSourceExecuteSqlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSourceExecuteSqlResponse>;
        }));
    }

    protected processProductSourceExecuteSql(response: HttpResponseBase): Observable<ProductSourceExecuteSqlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductSourceExecuteSqlResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecurringValidateDataModelsOptions(organisationId: number): Observable<RecurringValidateDataModelsOptionsDto> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/validate-data-models/schedule";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecurringValidateDataModelsOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecurringValidateDataModelsOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecurringValidateDataModelsOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecurringValidateDataModelsOptionsDto>;
        }));
    }

    protected processGetRecurringValidateDataModelsOptions(response: HttpResponseBase): Observable<RecurringValidateDataModelsOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecurringValidateDataModelsOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setRecurringValidateDataModelsOptions(organisationId: number, options: RecurringValidateDataModelsOptionsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/validate-data-models/schedule";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRecurringValidateDataModelsOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRecurringValidateDataModelsOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetRecurringValidateDataModelsOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpendMonitorMashupState(organisationId: number): Observable<SpendMonitorMashupStateDto> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/spendmonitormashup/state";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpendMonitorMashupState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpendMonitorMashupState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpendMonitorMashupStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpendMonitorMashupStateDto>;
        }));
    }

    protected processGetSpendMonitorMashupState(response: HttpResponseBase): Observable<SpendMonitorMashupStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpendMonitorMashupStateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminOrganisationSecretService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    list(organisationId: number): Observable<ListOrganisationSecretDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/Secrets/{organisationId}/List";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListOrganisationSecretDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListOrganisationSecretDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListOrganisationSecretDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOrganisationSecretDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdate(addOrUpdateDto: AddOrUpdateOrganisationSecretDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Organisations/Secrets/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminOrganisationSettingsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEmailConfiguration(organisationId: number): Observable<EmailSenderConfigurationDto> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/settings/email";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSenderConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSenderConfigurationDto>;
        }));
    }

    protected processGetEmailConfiguration(response: HttpResponseBase): Observable<EmailSenderConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSenderConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setEmailConfiguration(organisationId: number, configurationDto: EmailSenderConfigurationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/organisations/{organisationId}/settings/email";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEmailConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEmailConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetEmailConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listProducts(): Observable<ListProductDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Products/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProductDto[]>;
        }));
    }

    protected processListProducts(response: HttpResponseBase): Observable<ListProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProductDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProduct(productId: number): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/Admin/Products/Get/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setProduct(productDto: AddOrUpdateProductDto): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/Admin/Products/Set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processSetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProduct(productId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Products/Delete/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDatasetFields(fileName: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/Products/ExportDatasetFields?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDatasetFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDatasetFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDatasetFields(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportProducts(fileName: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/Products/Export?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportProducts(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importProducts(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Products/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminProductUpgradeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listProductUpgrades(): Observable<ListProductUpgradeDto[]> {
        let url_ = this.baseUrl + "/api/Admin/ProductUpgrade/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListProductUpgrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProductUpgrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProductUpgradeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProductUpgradeDto[]>;
        }));
    }

    protected processListProductUpgrades(response: HttpResponseBase): Observable<ListProductUpgradeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProductUpgradeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    detectedProductUpgrades(): Observable<AvailableUpgradeDto[]> {
        let url_ = this.baseUrl + "/api/Admin/ProductUpgrade/DetectedProductUpgrades";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetectedProductUpgrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetectedProductUpgrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableUpgradeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableUpgradeDto[]>;
        }));
    }

    protected processDetectedProductUpgrades(response: HttpResponseBase): Observable<AvailableUpgradeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableUpgradeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkUpgradeAvailability(id: number): Observable<AvailableUpgradeDto> {
        let url_ = this.baseUrl + "/api/Admin/ProductUpgrade/CheckUpgradeAvailability/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUpgradeAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUpgradeAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableUpgradeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableUpgradeDto>;
        }));
    }

    protected processCheckUpgradeAvailability(response: HttpResponseBase): Observable<AvailableUpgradeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableUpgradeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    performUpgrade(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ProductUpgrade/PerformUpgrade/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformUpgrade(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformUpgrade(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPerformUpgrade(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminProductVersionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listForProduct(productId: number): Observable<ProductVersionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/ListForProduct/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVersionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVersionDto[]>;
        }));
    }

    protected processListForProduct(response: HttpResponseBase): Observable<ProductVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductVersionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<ProductVersionDto> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVersionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdate(versionDto: AddOrUpdateProductVersionDto): Observable<ProductVersionDto> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(versionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVersionDto>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<ProductVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(versionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/Delete/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModel(versionId: number): Observable<DataModelDto> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/{versionId}/Model";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelDto>;
        }));
    }

    protected processGetModel(response: HttpResponseBase): Observable<DataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setModel(versionId: number, modelDto: DataModelDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/{versionId}/Model";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postProcessModel(versionId: number, modelDto: DataModelDto): Observable<DataModelDto> {
        let url_ = this.baseUrl + "/api/Admin/ProductVersions/{versionId}/Model/PostProcess";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostProcessModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProcessModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataModelDto>;
        }));
    }

    protected processPostProcessModel(response: HttpResponseBase): Observable<DataModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataModelDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminSiteContentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(organisationId: number, type: SiteContentType): Observable<SiteContentDto> {
        let url_ = this.baseUrl + "/api/Admin/SiteContent/Get/{organisationId}/{type}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteContentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SiteContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SiteContentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    set(organisationId: number, type: SiteContentType, content: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/SiteContent/Set/{organisationId}/{type}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminSpendService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProductVersions(): Observable<ListProductVersionDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Spend";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProductVersionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProductVersionDto[]>;
        }));
    }

    protected processGetProductVersions(response: HttpResponseBase): Observable<ListProductVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProductVersionDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importPivot(file: FileParameter | null | undefined, organisationId: number | undefined, user: string | null | undefined, duplicateHandling: string | null | undefined): Observable<ImportVisualResultDto> {
        let url_ = this.baseUrl + "/api/Admin/Spend/ImportPivot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (organisationId === null || organisationId === undefined)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else
            content_.append("organisationId", organisationId.toString());
        if (user !== null && user !== undefined)
            content_.append("user", user.toString());
        if (duplicateHandling !== null && duplicateHandling !== undefined)
            content_.append("duplicateHandling", duplicateHandling.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPivot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPivot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportVisualResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportVisualResultDto>;
        }));
    }

    protected processImportPivot(response: HttpResponseBase): Observable<ImportVisualResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportVisualResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpendDuplicateImportErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importPivots(files: FileParameter[] | null | undefined, organisationId: number | undefined, user: string | null | undefined): Observable<ImportVisualsResultDto> {
        let url_ = this.baseUrl + "/api/Admin/Spend/ImportPivots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (organisationId === null || organisationId === undefined)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else
            content_.append("organisationId", organisationId.toString());
        if (user !== null && user !== undefined)
            content_.append("user", user.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPivots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPivots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportVisualsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportVisualsResultDto>;
        }));
    }

    protected processImportPivots(response: HttpResponseBase): Observable<ImportVisualsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportVisualsResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMappings(productVersionId: number): Observable<SpendPivotStudioMappingsDto> {
        let url_ = this.baseUrl + "/api/Admin/Spend/GetMappings/{productVersionId}";
        if (productVersionId === undefined || productVersionId === null)
            throw new globalThis.Error("The parameter 'productVersionId' must be defined.");
        url_ = url_.replace("{productVersionId}", encodeURIComponent("" + productVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpendPivotStudioMappingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpendPivotStudioMappingsDto>;
        }));
    }

    protected processGetMappings(response: HttpResponseBase): Observable<SpendPivotStudioMappingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpendPivotStudioMappingsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importMappings(productVersionId: number, file: FileParameter | null | undefined): Observable<DiagnosticCollectionDto> {
        let url_ = this.baseUrl + "/api/Admin/Spend/ImportMappings/{productVersionId}";
        if (productVersionId === undefined || productVersionId === null)
            throw new globalThis.Error("The parameter 'productVersionId' must be defined.");
        url_ = url_.replace("{productVersionId}", encodeURIComponent("" + productVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagnosticCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagnosticCollectionDto>;
        }));
    }

    protected processImportMappings(response: HttpResponseBase): Observable<DiagnosticCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiagnosticCollectionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listUsers(): Observable<ListUserDto[]> {
        let url_ = this.baseUrl + "/api/admin/user/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUserDto[]>;
        }));
    }

    protected processListUsers(response: HttpResponseBase): Observable<ListUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListUserDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearUserState(userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/user/{userId}/state/clear";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearUserState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearUserState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearHome(userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/user/{userId}/home/clear";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearHome(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearFavourites(userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/user/{userId}/favourites/clear";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearFavourites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearFavourites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearFavourites(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setRole(setUserRoleDto: SetUserRoleDto): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/user/role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setUserRoleDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminVisualExportImportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listExportableVisuals(): Observable<ListVisualDto[]> {
        let url_ = this.baseUrl + "/api/Admin/Visuals/ListExportable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListExportableVisuals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListExportableVisuals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListVisualDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListVisualDto[]>;
        }));
    }

    protected processListExportableVisuals(response: HttpResponseBase): Observable<ListVisualDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListVisualDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportVisual(visualId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/Visuals/ExportVisual/{visualId}";
        if (visualId === undefined || visualId === null)
            throw new globalThis.Error("The parameter 'visualId' must be defined.");
        url_ = url_.replace("{visualId}", encodeURIComponent("" + visualId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportVisual(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importVisual(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/Visuals/ImportVisual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportVisual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportVisual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportVisual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SiteContentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(type: SiteContentType): Observable<SiteContentDto> {
        let url_ = this.baseUrl + "/api/app/site-content/{type}";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteContentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteContentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SiteContentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SiteContentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GainsightPXService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSettings(): Observable<GainsightUserSettings> {
        let url_ = this.baseUrl + "/api/GainsightPX/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GainsightUserSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GainsightUserSettings>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<GainsightUserSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GainsightUserSettings;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ClientConfigDto {
    apiBaseUrl?: string | undefined;
    authority?: string | undefined;
    changePasswordUrl?: string | undefined;
    clientId?: string | undefined;
    scope?: string | undefined;
    deploymentInfo?: IDeploymentInfo | undefined;
    sessionConfig?: ClientSessionConfigDto | undefined;
    regions?: ClientRegionConfigDto[] | undefined;
}

export interface IDeploymentInfo {
    environmentName?: string | undefined;
    releaseId?: string | undefined;
    baseUrl?: string | undefined;
    versionName?: string | undefined;
    databaseServers?: string[] | undefined;
    region?: string | undefined;
}

export interface ClientSessionConfigDto {
    showSessionExpiryDialogPeriodMs?: number;
    accessTokenRefreshPeriodMs?: number;
}

export interface ClientRegionConfigDto {
    name?: string | undefined;
    url?: string | undefined;
}

export interface AppMaintenanceModeDto {
    active?: boolean;
    minRole?: UserRole;
    endDateUtc?: string | undefined;
}

export enum UserRole {
    ClientUser = 0,
    InsightsUser = 1,
    ClientAdmin = 2,
    InsightsAdmin = 3,
    Developer = 4,
}

export enum UserAppAccessStatus {
    Unauthorized = 0,
    Accessible = 1,
    InaccessibleMaintenance = 2,
}

export interface ExternalScriptDto {
    type?: ExternalScriptType;
    source?: string | undefined;
}

export enum ExternalScriptType {
    InlineScript = 0,
    ExternalScript = 1,
}

export interface AppSettingsDto {
    currency?: string | undefined;
    locale?: string | undefined;
    timeZoneIana?: string | undefined;
    notificationSettings?: NotificationSettingsDto | undefined;
}

export interface NotificationSettingsDto {
    notificationsEnabled?: boolean;
    toastViewPortLocation?: number;
    sections?: NotificationSectionSettingsDto[];
}

export interface NotificationSectionSettingsDto {
    category?: NotificationCategory;
    toastsEnabled?: boolean;
    panelEnabled?: boolean;
    soundsEnabled?: boolean;
}

export enum NotificationCategory {
    All = 0,
    Unlocked = 1,
    ExtDatasetFinishedLoading = 2,
    SchedulerRunNowComplete = 3,
}

export interface AppCurrenciesDto {
    currencies?: CurrencyDto[] | undefined;
    baseCurrencyCode?: string | undefined;
}

export interface CurrencyDto {
    currencyName?: string | undefined;
    currencyCode?: string | undefined;
    symbol?: string | undefined;
}

export interface AppWalkMeParametersDto {
    company?: string | undefined;
    username?: string | undefined;
    version?: string | undefined;
}

export interface UserAppFeaturesDto {
    general?: UserGeneralFeaturesDto | undefined;
    visualRendering?: UserVisualRenderingFeaturesDto | undefined;
    visualExport?: UserVisualExportFeaturesDto | undefined;
    userDefinedFields?: UserUserDefinedFieldFeaturesDto | undefined;
    extendedDatasets?: UserExtendedDatasetFeaturesDto | undefined;
    pivotStudio?: UserPivotStudioFeaturesDto | undefined;
    ui?: UserUIFeaturesDto | undefined;
    dataQuery?: DataQueryFeaturesDto | undefined;
    uI2?: UIFeatures2Dto | undefined;
}

export interface OrganisationGeneralFeaturesDto {
    enterpriseReporting?: boolean;
    showSessionExpiryPanel?: boolean;
    enableProductUpgradeCheck?: boolean;
}

export interface UserGeneralFeaturesDto extends OrganisationGeneralFeaturesDto {
    cacheOptionsInVisualList?: boolean;
    organisationSelect?: boolean;
    userImpersonation?: boolean;
}

export interface OrganisationVisualRenderingFeaturesDto {
}

export interface UserVisualRenderingFeaturesDto extends OrganisationVisualRenderingFeaturesDto {
}

export interface OrganisationVisualExportFeaturesDto {
}

export interface UserVisualExportFeaturesDto extends OrganisationVisualExportFeaturesDto {
    pivotTableExport?: boolean;
    pngExport?: boolean;
    excelChartImage?: boolean;
    exportLayout?: boolean;
}

export interface OrganisationUserDefinedFieldFeaturesDto {
    requestsDisableEmployeeUDFs?: boolean;
}

export interface UserUserDefinedFieldFeaturesDto extends OrganisationUserDefinedFieldFeaturesDto {
}

export interface OrganisationExtendedDatasetFeaturesDto {
    databaseDatasetDefinitions?: boolean;
    allowProfiling?: boolean;
}

export interface UserExtendedDatasetFeaturesDto extends OrganisationExtendedDatasetFeaturesDto {
}

export interface OrganisationPivotStudioFeaturesDto {
    allowUserSort?: boolean;
    importExportDefinition?: boolean;
    filterToggle?: boolean;
    collapseAllSections?: boolean;
    allowExtendedDatasetRefreshCancellation?: boolean;
    listReturnAllUserVisuals?: boolean;
    visualListRefresh?: boolean;
    reloadVisual?: boolean;
    editOrCopyVisualFromDashboard?: boolean;
    seeErrorDetails?: boolean;
    newLayout?: boolean;
}

export interface UserPivotStudioFeaturesDto extends OrganisationPivotStudioFeaturesDto {
}

export interface OrganisationUIFeaturesDto {
    listViewMultiSelect?: boolean;
    dataHealthSuperAdmin?: boolean;
    dataHealthSupportAdmin?: boolean;
    dataHealthAdmin?: boolean;
    dataHealthBusinessUser?: boolean;
    visualListCaching?: boolean;
    dashboardListCaching?: boolean;
    contentAccessUseImpersonateeRole?: boolean;
}

export interface UserUIFeaturesDto extends OrganisationUIFeaturesDto {
}

export interface DataQueryFeaturesDto {
    disableClientSideCache?: boolean | undefined;
    disableServerSideCache?: boolean | undefined;
    enableIndexCreation?: boolean | undefined;
    aggressiveCachedQueryReuseInUI?: boolean | undefined;
    useCachedQueriesInExports?: boolean | undefined;
    recordPlansForFrontendQueries?: boolean | undefined;
    recordPlansForExportQueries?: boolean | undefined;
    limitExportedRowCount?: boolean | undefined;
    disableFilterTargetReduction?: boolean | undefined;
}

export interface UIFeatures2Dto {
    localeDropdown?: boolean | undefined;
    createWithAIButton?: boolean | undefined;
    crossFilterVisualIcon?: UserRole | undefined;
    useNewPivotTableExport?: boolean | undefined;
    enableHideTotals?: boolean | undefined;
}

export interface VolatileAppSettingsDto {
    hasLastRun?: boolean;
    spendETLStatus?: SpendETLStatusDto | undefined;
}

export interface SpendETLStatusDto {
    etlRunId?: number;
    etlRunStatus?: number;
    startDate?: string;
    endDate?: string | undefined;
    historicRuns?: ETLRunDto[] | undefined;
}

export interface ETLRunDto {
    id?: number;
    organisationId?: number;
    etlType?: ETLType;
    dataSourceVersion?: string | undefined;
    etlRunId?: number;
    etlRunStatus?: ETLRunStatus;
    runDescription?: string | undefined;
    runStartDate?: string;
    runEndDate?: string | undefined;
    pollCount?: number;
    opsWarningIssued?: boolean;
    opsWarningIssueDate?: string | undefined;
    opsErrorIssued?: boolean;
    opsErrorIssueDate?: string | undefined;
    justFinished?: boolean;
}

export enum ETLType {
    Spend = 0,
}

export enum ETLRunStatus {
    Success = 0,
    Error = 1,
    Running = 2,
    Unknown = 3,
}

export interface UserContentAccessDto {
    view?: boolean;
    edit?: boolean;
    delete?: boolean;
    copy?: boolean;
}

export enum UserContentType {
    Visual = "visual",
    Dashboard = "dashboard",
    Schedule = "schedule",
    PublishedReport = "publishedReport",
}

export enum UserAccessContext {
    ViewMode = 0,
    Export = 1,
    PublishedContent = 2,
    VisualEditor = 3,
    DashboardEditor = 4,
    SchedulerEditor = 5,
    PublishedReportEditor = 6,
}

export interface ContentSelectorItemDto {
    id?: number;
    name?: string | undefined;
    fromLibrary?: boolean;
    shared?: boolean;
    sample?: boolean;
    favourite?: boolean;
    description?: string | undefined;
    categories?: ContentItemCategoryDto[] | undefined;
    ownerId?: number | undefined;
    ownerName?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedAt?: string;
}

export interface ContentSelectorDashboardDto extends ContentSelectorItemDto {
    dashboard?: ListUserDashboardDto | undefined;
    datasets?: ContentDatasetDto[] | undefined;
}

export interface DashboardDetailsDto {
    id?: number;
    organisationId?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    type?: DashboardType;
    name?: string | undefined;
    description?: string | undefined;
    reportGuid?: string | undefined;
    fromLibrary?: boolean;
    shared?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    dynamicFilteringStatus?: DashboardDynamicFilteringStatus;
    createdById?: number | undefined;
}

export interface ListDashboardDto extends DashboardDetailsDto {
    categoryIds?: number[] | undefined;
    scheduled?: boolean;
    published?: boolean;
    layout?: string | undefined;
    visuals?: DashboardVisualDetailsDto[] | undefined;
    filters?: FilterDto[] | undefined;
}

export interface ListUserDashboardDto extends ListDashboardDto {
    favourite?: boolean;
    home?: boolean;
}

export interface DashboardVisualDetailsDto {
    visualId?: number | undefined;
    userDatasetId?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    unshared?: boolean;
    deleted?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    ownerId?: number | undefined;
    ownerName?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    schemaName?: string | undefined;
}

export enum AppliedDynamicFilters {
    None = 0,
    SpendEmployeeCode = 1,
    SpendDepartmentNames = 2,
}

export interface SchemaTargetDto {
    type: SchemaType;
    name?: string | undefined;
}

export enum SchemaType {
    Core = 0,
    UserDataset = 1,
    ResultSet = 2,
}

export interface CoreSchemaTargetDto extends SchemaTargetDto {
    product?: string | undefined;
}

export interface UserDatasetSchemaTargetDto extends SchemaTargetDto {
    userDatasetId?: number;
}

export interface ResultSetSchemaTargetDto extends SchemaTargetDto {
    resultSetId?: string;
}

export interface FilterDto {
    filterType: FilterType;
    enabled?: boolean | undefined;
    groupByTarget?: boolean | undefined;
}

export enum FilterType {
    Advanced = 0,
    Basic = 1,
    RelativeDate = 4,
    TopN = 5,
    RelativeTime = 7,
    Expr = 1000,
    Dynamic = -1001,
}

export interface DynamicFilterDto extends FilterDto {
    target?: SchemaFieldTargetDto | undefined;
    value?: DynamicFilterValue;
}

export interface SchemaFieldTargetDto {
    schema: SchemaTargetDto;
    group: string;
    field: string;
    childField?: string | undefined;
    displayName?: string | undefined;
    aggregation?: DataAggregationFunction | undefined;
    visualId?: number | undefined;
}

export enum DataAggregationFunction {
    DoNotSummarize = "DoNotSummarize",
    Count = "Count",
    CountNonNull = "CountNonNull",
    Sum = "Sum",
    Avg = "Avg",
    Max = "Max",
    Median = "Median",
    Min = "Min",
    StandardDeviation = "StandardDeviation",
    Variance = "Variance",
}

export enum DynamicFilterValue {
    SpendEmployeeCode = "SpendEmployeeCode",
    SpendDepartmentNames = "SpendDepartmentNames",
}

export interface AdvancedFilterDto extends FilterDto {
    target?: SchemaFieldTargetDto | undefined;
    logicalOperator?: AdvancedFilterLogicalOperator;
    conditions?: AdvancedFilterConditionDto[] | undefined;
}

export enum AdvancedFilterLogicalOperator {
    And = "And",
    Or = "Or",
}

export interface AdvancedFilterConditionDto {
    value?: any | undefined;
    operator?: AdvancedFilterConditionOperator;
}

export enum AdvancedFilterConditionOperator {
    None = "None",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Contains = "Contains",
    DoesNotContain = "DoesNotContain",
    StartsWith = "StartsWith",
    DoesNotStartWith = "DoesNotStartWith",
    Is = "Is",
    IsNot = "IsNot",
    IsBlank = "IsBlank",
    IsNotBlank = "IsNotBlank",
}

export interface BasicFilterDto extends FilterDto {
    target?: SchemaFieldTargetDto | undefined;
    operator?: BasicFilterOperator;
    values?: any[] | undefined;
}

export enum BasicFilterOperator {
    In = "In",
    NotIn = "NotIn",
    All = "All",
}

export interface RelativeDateFilterDto extends FilterDto {
    target?: SchemaFieldTargetDto | undefined;
    operator?: RelativeDateOrTimeOperator;
    timeUnitsCount?: number | undefined;
    timeUnitType?: RelativeDateTimeFilterUnit;
    includeToday?: boolean;
    timeUnitsCount2?: number | undefined;
    timeUnitType2?: RelativeDateTimeFilterUnit | undefined;
}

export enum RelativeDateOrTimeOperator {
    InLast = 0,
    InThis = 1,
    InNext = 2,
    OutsideRange = -4,
    InRange = -3,
    OlderThan = -2,
}

export enum RelativeDateTimeFilterUnit {
    Days = 0,
    Weeks = 1,
    CalendarWeeks = 2,
    Months = 3,
    CalendarMonths = 4,
    Years = 5,
    CalendarYears = 6,
    Minutes = 7,
    Hours = 8,
    SpendPeriod = -5,
    CalendarHalfYears = -4,
    CalendarQuarters = -2,
    Quarters = -1,
}

export interface RelativeTimeFilterDto extends FilterDto {
    target?: SchemaFieldTargetDto | undefined;
    operator?: RelativeDateOrTimeOperator;
    timeUnitsCount?: number | undefined;
    timeUnitType?: RelativeDateTimeFilterUnit;
    timeUnitsCount2?: number | undefined;
    timeUnitType2?: RelativeDateTimeFilterUnit | undefined;
}

export interface TopNFilterDto extends FilterDto {
    operator?: TopNFilterOperator;
    itemCount?: number;
    orderBy?: SchemaFieldTargetDto | undefined;
}

export enum TopNFilterOperator {
    Top = "Top",
    Bottom = "Bottom",
}

export interface ExprFilterDto extends FilterDto {
    schema?: SchemaTargetDto | undefined;
    expr?: string | undefined;
}

export enum DashboardType {
    Insights = 0,
    PowerBiReport = 1,
}

export enum DashboardDynamicFilteringStatus {
    Unfiltered = 0,
    DashboardFiltersApplied = 1,
    NotAllVisualsFiltered = 2,
    AllVisualsFiltered = 4,
}

export interface ContentDatasetDto {
    schemaTarget?: SchemaTargetDto | undefined;
    name?: string | undefined;
}

export interface ContentItemCategoryDto {
    itemCategoryId?: number;
    name?: string | undefined;
    products?: ContentProductDto[] | undefined;
}

export interface ContentProductDto {
    productId?: number;
    name?: string | undefined;
}

export interface ContentSelectorVisualDto extends ContentSelectorItemDto {
    visual?: ListUserVisualDto | undefined;
    dataset?: ContentDatasetDto;
}

export interface ListVisualDto {
    id?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    schemaName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    categoryIds?: number[] | undefined;
    sample?: boolean;
    fromLibrary?: boolean;
    shared?: boolean;
    type?: string | undefined;
    fields?: VisualFieldDto[] | undefined;
    filters?: FilterDto[] | undefined;
    customFields?: CustomFieldDto[] | undefined;
    preferences?: VisualPreferencesDto | undefined;
    userDatasetId?: number | undefined;
    userDatasetExpired?: boolean;
    userDatasetRefreshing?: boolean;
    supportsCurrency?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    scheduled?: boolean;
    published?: boolean;
    organisationId?: number;
    organisationName?: string | undefined;
    createdById?: number | undefined;
    subtitle?: string | undefined;
    userDatasetLatestRefreshResult?: UserDatasetRefreshStatus | undefined;
}

export interface ListUserVisualDto extends ListVisualDto {
    favourite?: boolean;
    home?: boolean;
}

export interface VisualFieldDto {
    target: SchemaFieldTargetDto;
    usage?: string | undefined;
    customName?: string | undefined;
    sortDirection?: SortDirection | undefined;
    id?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
    sortOrder?: number | undefined;
    sorted?: boolean | undefined;
    pivotUsage?: DataFieldUsage | undefined;
    displayOrder?: number | undefined;
}

export enum SortDirection {
    Ascending = 1,
    Descending = 2,
}

export enum DataFieldUsage {
    Grouping = "Grouping",
    Detail = "Detail",
    Measure = "Measure",
}

export interface CustomFieldDto {
    name?: string;
    sourceText?: string | undefined;
    format?: CustomFieldFormat;
    numberRounding?: NumberRoundingMethod;
    decimalPrecision?: number | undefined;
    showThousandSeparator?: boolean;
    significantDigitsOnly?: boolean;
    currency?: DataCurrencyDisplay;
    dateFormat?: DataDateFormat;
    timeFormat?: DataTimeFormat;
    nullText?: string | undefined;
    dataType?: ValueDataType | undefined;
    isAggregated?: boolean;
    hasErrors?: boolean;
    usageHints?: DataFieldUsageHints | undefined;
}

export enum CustomFieldFormat {
    Unknown = 0,
    Number = 1,
    Currency = 2,
    Percentage = 3,
    DateOnly = 4,
    DateTime = 5,
    TimeOnly = 6,
    Text = 7,
}

export enum NumberRoundingMethod {
    Floor = "floor",
    Ceil = "ceil",
    AwayFromZero = "awayFromZero",
    Nearest = "nearest",
    Truncate = "truncate",
}

export interface DataCurrencyDisplay {
    sign?: DataCurrencySign;
    layout?: DataCurrencyLayout;
    negativeDisplay?: DataCurrencyNegativeDisplay;
}

export enum DataCurrencySign {
    None = "None",
    Sign = "Sign",
    Code = "Code",
}

export enum DataCurrencyLayout {
    Default = "Default",
    Accounting = "Accounting",
}

export enum DataCurrencyNegativeDisplay {
    WithValue = "WithValue",
    WithSign = "WithSign",
}

export enum DataDateFormat {
    Short = "Short",
    Long = "Long",
    YearPeriod = "YearPeriod",
    DayOfMonth = "DayOfMonth",
}

export enum DataTimeFormat {
    NoSeconds = "NoSeconds",
    Full = "Full",
}

export enum ValueDataType {
    Unknown = "unknown",
    Boolean = "boolean",
    Integer = "integer",
    Number = "number",
    Decimal = "decimal",
    DateOnly = "date",
    TimeOnly = "time",
    DateTime = "datetime",
    Text = "text",
    List = "list",
    Map = "map",
}

export interface DataFieldUsageHints {
    timeValueKind?: DataFieldTimeValueKind | undefined;
    totalsHidden?: boolean;
}

export enum DataFieldTimeValueKind {
    DateTime = "DateTime",
    Year = "Year",
    Quarter = "Quarter",
    YearAndQuarter = "YearAndQuarter",
    Month = "Month",
    MonthName = "MonthName",
    YearAndMonth = "YearAndMonth",
    Week = "Week",
    Day = "Day",
    WeekDay = "WeekDay",
    TimeOfDay = "TimeOfDay",
    Time = "Time",
    Hour = "Hour",
    Minute = "Minute",
    Second = "Second",
    SpendPeriod = "SpendPeriod",
    YearAndSpendPeriod = "YearAndSpendPeriod",
}

export interface VisualPreferencesDto {
    currency?: string | undefined;
}

export enum UserDatasetRefreshStatus {
    Pending = 0,
    Running = 1,
    Succeeded = 2,
    Failed = 3,
    Cancelled = 4,
}

export interface StoredFileInfoDto {
    category?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    sizeInBytes?: number;
    expiresOn?: string | undefined;
    deleted?: boolean;
    url?: string | undefined;
}

export interface ErrorDto {
    error?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface ListFileUploadConfigDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
}

export interface ListItemCategoryDto {
    id?: number;
    name?: string | undefined;
    productId?: number;
    productName?: string | undefined;
}

export interface UserJobStateDto {
    jobId?: number;
    status?: JobStatus;
    progress?: number | undefined;
    estimatedCompletionTime?: string | undefined;
    startedDate?: string | undefined;
    finishedDate?: string | undefined;
    error?: string | undefined;
}

export enum JobStatus {
    Pending = 0,
    Running = 1,
    Finished = 2,
    Failed = 3,
}

export interface LocaleDto {
    id?: string | undefined;
    name?: string | undefined;
    formats?: LocaleFormats | undefined;
    numberFormatExample?: string | undefined;
}

export interface LocaleFormats {
    numeric?: LocaleNumericFormats | undefined;
    timestamp?: LocaleTimestampFormats | undefined;
}

export interface LocaleNumericFormats {
    number?: string | undefined;
    wholeNumber?: string | undefined;
    currency?: string | undefined;
    groupSymbols?: { [key: string]: string; } | undefined;
}

export interface LocaleTimestampFormats {
    date?: string | undefined;
    time?: string | undefined;
    timeNoSeconds?: string | undefined;
    dateTime?: string | undefined;
    dateTimeNoSeconds?: string | undefined;
    yearAndPeriod?: string | undefined;
    dayOfMonth?: string | undefined;
}

export interface ListVersionedProductDto {
    id?: number;
    name?: string | undefined;
    version?: ListProductVersionDto | undefined;
}

export interface ListProductVersionDto {
    id?: number;
    name?: string | undefined;
}

export interface ProductUrlDto {
    productName?: string | undefined;
    productUrl?: string | undefined;
}

export interface DashboardIsDuplicateDto {
    isDuplicate?: boolean;
}

export interface DashboardDuplicateCheckDto {
    dashboardId?: number;
    name?: string | undefined;
}

export interface DashboardDto extends DashboardDetailsDto {
    categoryIds?: number[] | undefined;
    content?: DashboardContentDto | undefined;
    filters?: FilterDto[] | undefined;
    dynamicFilters?: AppliedDynamicFilters;
}

export interface DashboardContentDto {
    layout?: string | undefined;
    visuals?: DashboardVisualDto[] | undefined;
}

export interface DashboardVisualDto {
    visualId?: number | undefined;
    order?: number;
    userDatasetId?: number | undefined;
    unshared?: boolean;
    sharedWithOthers?: boolean;
    deleted?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    fromLibrary?: boolean;
    name?: string | undefined;
    type?: string | undefined;
    ownerId?: number | undefined;
    ownerName?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    schemaName?: string | undefined;
}

export interface AddOrUpdateDashboardDto {
    id?: number;
    organisationId?: number;
    type?: DashboardType;
    name?: string | undefined;
    createdBy?: string | undefined;
    description?: string | undefined;
    categoryIds?: number[] | undefined;
    reportGuid?: string | undefined;
    fromLibrary?: boolean;
    shared?: boolean;
    content?: DashboardContentDto | undefined;
    filters?: FilterDto[] | undefined;
}

export interface DashboardUsageDto {
    inSchedule?: boolean;
    published?: boolean;
}

export interface DashboardVisualInfoDto {
    organisationId?: number;
    visualId?: number;
    visualName?: string | undefined;
    visualType?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    schemaName?: string | undefined;
    createdBy?: string | undefined;
    deleted?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    createdById?: number | undefined;
}

export interface DashboardVisualReconciliationInfoDto {
    visualId?: number;
    state?: DashboardVisualAccessState;
    visualName?: string | undefined;
    visualType?: string | undefined;
    schemaName?: string | undefined;
    createdBy?: string | undefined;
}

export enum DashboardVisualAccessState {
    Accessible = 0,
    Unshared = 1,
    Deleted = 2,
}

export interface DashboardVisualContentDto extends DashboardVisualDto {
    description?: string | undefined;
    userDatasetState?: UserDatasetState | undefined;
    dynamicFilters?: AppliedDynamicFilters;
    visual?: VisualContentDto | undefined;
    createdBy?: string | undefined;
    userDatasetLatestRefreshResult?: UserDatasetRefreshStatus | undefined;
    userDatasetLatestRefreshResultTimestamp?: string | undefined;
}

export enum UserDatasetState {
    Pending = 0,
    Deleted = 1,
    NoData = 2,
    HasData = 3,
}

export interface VisualContentDto {
    type?: string | undefined;
    title?: string | undefined;
    currency?: string | undefined;
    fields?: VisualFieldDto[] | undefined;
    filters?: FilterDto[] | undefined;
    customFields?: CustomFieldDto[] | undefined;
    userSorted?: boolean;
    state?: string | undefined;
    style?: string | undefined;
    subtitle?: string | undefined;
}

export interface JobReferenceDto {
    id?: number | undefined;
}

export interface ExportDashboardToPdfDto {
    includeHeader?: boolean;
    includeFooter?: boolean;
    paperSize?: PdfPaperSize;
    filters?: FilterDto[] | undefined;
    renderUnshared?: boolean;
    format?: ContentExportFormat;
    locale?: string | undefined;
}

export enum PdfPaperSize {
    Letter = 1,
    Default = 2,
    A4 = 2,
}

export enum ContentExportFormat {
    Pdf = 0,
    Jpeg = 1,
    Png = 2,
}

export interface ExportDashboardToPdfResultDto {
    fileUrl?: string | undefined;
    fileName?: string | undefined;
}

export interface UserDashboardDto {
    dashboardId?: number;
    favourite?: boolean | undefined;
    home?: boolean | undefined;
}

export interface AdvancedDatasetDto {
    id: string;
    sourceType: DatasetSourceType;
    details: DatasetDetailsDto;
    fields: AdvancedDatasetFieldDto[];
    inputs: AdvancedDatasetInputDto[];
}

export enum DatasetSourceType {
    StoredProcedure = "StoredProcedure",
}

export interface DatasetDetailsDto {
    group?: string | undefined;
    groupOrder?: number;
    name?: string | undefined;
    description?: string | undefined;
    previouslyKnownAs?: string | undefined;
}

export interface AdvancedDatasetFieldDto {
    id?: string | undefined;
    name?: string | undefined;
    order?: number;
    hidden?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    exclude?: boolean;
    dataType?: LegacyDataType | undefined;
    decimalPrecision?: number | undefined;
    usageHints?: DataFieldUsageHints | undefined;
}

export enum LegacyDataType {
    Unknown = 0,
    Text = 1,
    Currency = 2,
    Decimal = 2,
    Number = 3,
    WholeNumber = 4,
    Integer = 4,
    Boolean = 5,
    Date = 6,
    DateOnly = 6,
    DateTime = 7,
    Time = 9,
    TimeOnly = 9,
    Binary = 11,
}

export interface AdvancedDatasetInputDto {
    id?: string | undefined;
    details?: AdvancedDatasetInputDetailsDto | undefined;
    type?: AdvancedDatasetInputType;
}

export interface AdvancedDatasetInputDetailsDto {
    kind?: AdvancedDatasetInputKind;
    group?: string | undefined;
    groupOrder?: number;
    name?: string | undefined;
    description?: string | undefined;
    required?: boolean;
    defaultValue?: any | undefined;
    hidden?: boolean;
    displayGroup?: string | undefined;
    alwaysIncluded?: boolean;
    requiredGroup?: string | undefined;
    maximumDateRange?: number;
}

export enum AdvancedDatasetInputKind {
    Control = "Control",
    Filter = "Filter",
}

export enum AdvancedDatasetInputType {
    Checkbox = "Checkbox",
    Text = "Text",
    WholeNumber = "WholeNumber",
    Number = "Number",
    Currency = "Currency",
    CurrencyRange = "CurrencyRange",
    Date = "Date",
    DateRange = "DateRange",
    Dropdown = "Dropdown",
    RelativeDates = "RelativeDates",
    RelativeYearPeriod = "RelativeYearPeriod",
    YearPeriod = "YearPeriod",
    NumberRange = "NumberRange",
}

export interface AdvancedDatasetCheckboxInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    trueValue?: any | undefined;
    falseValue?: any | undefined;
}

export interface AdvancedDatasetTextInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    maxLength?: number | undefined;
}

export interface AdvancedDatasetWholeNumberInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export interface AdvancedDatasetNumberInputBaseDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    precision?: number | undefined;
}

export interface AdvancedDatasetNumberInputDto extends AdvancedDatasetNumberInputBaseDto {
}

export interface AdvancedDatasetCurrencyInputDto extends AdvancedDatasetNumberInputBaseDto {
}

export interface AdvancedDatasetCurrencyRangeInputDto extends AdvancedDatasetNumberInputBaseDto {
}

export interface AdvancedDatasetDateInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    includeTime?: boolean;
}

export interface AdvancedDatasetDateRangeInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    includeTime?: boolean;
}

export interface AdvancedDatasetDropdownInputDto extends AdvancedDatasetInputDto {
    value?: any | undefined;
    label?: string | undefined;
    searchable?: boolean;
    minSearchTermLength?: number;
    multiple?: boolean;
    autoSelectOnlyOption?: boolean;
}

export interface AdvancedDatasetRelativeDatesInputDto extends AdvancedDatasetInputDto {
    startParam?: string | undefined;
    endParam?: string | undefined;
    value?: AdvancedDatasetRelativeDatesInputValueDto | undefined;
}

export interface AdvancedDatasetRelativeDatesInputValueDto {
    operator?: AdvancedDatasetRelativeDatesOperator;
    unitsCount?: number | undefined;
    unitType?: RelativeDateTimeFilterUnit | undefined;
    units2Count?: number | undefined;
    unit2Type?: RelativeDateTimeFilterUnit | undefined;
    includeToday?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isComplete?: boolean;
}

export enum AdvancedDatasetRelativeDatesOperator {
    SpecificDates = 0,
    InLast = 1,
    InThis = 2,
    InNext = 3,
    Range = 4,
}

export interface AdvancedDatasetRelativeYearPeriodInputDto extends AdvancedDatasetInputDto {
    startYearParam?: string | undefined;
    startPeriodParam?: string | undefined;
    endYearParam?: string | undefined;
    endPeriodParam?: string | undefined;
    value?: AdvancedDatasetRelativeDatesInputValueDto | undefined;
}

export interface AdvancedDatasetYearPeriodInputDto extends AdvancedDatasetInputDto {
    yearParam?: string | undefined;
    periodParam?: string | undefined;
    value?: YearPeriod | undefined;
}

export interface YearPeriod {
    year?: number;
    period?: number;
}

export interface AdvancedDatasetNumberRangeInputDto extends AdvancedDatasetInputDto {
    startParam?: string | undefined;
    endParam?: string | undefined;
    min?: number | undefined;
    max?: number | undefined;
    value?: NumberRangeValue | undefined;
}

export interface NumberRangeValue {
    min?: number;
    max?: number;
}

export interface StoredProcedureDatasetDto extends AdvancedDatasetDto {
    procedureName: string;
    getFieldsProcName?: string | undefined;
}

export interface DatasetDefaultJoinFieldsLookupDto {
    items?: DatasetDefaultJoinFieldsLookupItemDto[] | undefined;
}

export interface DatasetDefaultJoinFieldsLookupItemDto {
    key?: DatasetTemplateReferencePairDto | undefined;
    fields?: JointDatasetFieldDto[] | undefined;
}

export interface DatasetTemplateReferencePairDto {
    left?: DatasetTemplateReferenceDto | undefined;
    right?: DatasetTemplateReferenceDto | undefined;
}

export interface DatasetTemplateReferenceDto {
    productName?: string | undefined;
    datasetId?: string | undefined;
}

export interface JointDatasetFieldDto {
    leftFieldId?: string | undefined;
    rightFieldId?: string | undefined;
}

export interface DropdownOptionDto {
    value?: any | undefined;
    label?: string | undefined;
    properties?: KeyValuePairOfStringAndObject[] | undefined;
    order?: number | undefined;
    onlyWhenMultiple?: boolean;
}

export interface KeyValuePairOfStringAndObject {
    key?: string | undefined;
    value?: any | undefined;
}

export interface GetDropdownOptionsDto {
    product?: string | undefined;
    datasetId?: string | undefined;
    dropdownId?: string | undefined;
    searchTerm?: string | undefined;
    parameters?: { [key: string]: AdvancedDatasetInputDto; } | undefined;
}

export interface ListUserDatasetDto {
    id?: number;
    name?: string | undefined;
    state?: UserDatasetState;
    products?: ListVersionedProductDto[] | undefined;
}

export interface UserDatasetDto {
    id?: number;
    userId?: number;
    organisationId?: number;
    name?: string | undefined;
    cacheDuration?: string | undefined;
    dataStoreId?: number | undefined;
    state?: UserDatasetState;
    content?: UserDatasetContentDto | undefined;
    lastRefreshed?: string | undefined;
    refreshDuration?: string | undefined;
    nextRefreshInSec?: number | undefined;
    dataExpiration?: string | undefined;
    latestRefreshResult?: UserDatasetRefreshStatus | undefined;
    latestRefreshResultTimestamp?: string | undefined;
    profile?: boolean;
    hasProfileData?: boolean;
    latestRefreshLog?: UserDatasetRefreshLogDto | undefined;
}

export interface UserDatasetContentDto {
    type?: UserDatasetContentType;
}

export enum UserDatasetContentType {
    Single = 0,
    Joint = 1,
}

export interface SingleUserDatasetContentDto extends UserDatasetContentDto {
    productName?: string | undefined;
    dataset?: AdvancedDatasetDto | undefined;
}

export interface JointUserDatasetContentDto extends UserDatasetContentDto {
    items?: JointUserDatasetItemDto[] | undefined;
    outputType?: JointUserDatasetOutputType;
}

export interface JointUserDatasetItemDto {
    productName?: string | undefined;
    dataset?: JointDatasetDto | undefined;
}

export interface JointDatasetDto {
    dataset?: AdvancedDatasetDto | undefined;
    joinType?: DatasetJoinType;
    fields?: JointDatasetFieldDto[] | undefined;
}

export enum DatasetJoinType {
    Inner = 0,
    LeftOuter = 1,
    RightOuter = 2,
    FullOuter = 3,
}

export enum JointUserDatasetOutputType {
    JoinedResult = 0,
    MultipleTablesAndView = 1,
}

export interface UserDatasetRefreshLogDto {
    legacy?: boolean;
    version?: number | undefined;
    requestReason?: UserDatasetRefreshReason | undefined;
    requestedBy?: UserDto | undefined;
    requestDateTimeUTC?: string | undefined;
    status?: UserDatasetRefreshStatus;
    startedDateTimeUTC?: string | undefined;
    finishedDateTimeUTC?: string | undefined;
    error?: string | undefined;
    stages?: UserDatasetRefreshLogStageDto[] | undefined;
}

export enum UserDatasetRefreshReason {
    ByUser = 0,
    ByAPIExport = 1,
    Schedule = 2,
}

export interface UserDto {
    id?: number;
    username?: string | undefined;
    role?: UserRole;
    settings?: AppSettingsDto | undefined;
}

export interface UserDatasetRefreshLogStageDto {
    type?: UserDatasetRefreshStageType;
    status?: UserDatasetRefreshStatus;
    startedDateTimeUTC?: string;
    finishedDateTimeUTC?: string | undefined;
    error?: string | undefined;
    substages?: UserDatasetRefreshLogSubStageDto[] | undefined;
}

export enum UserDatasetRefreshStageType {
    Initialization = 0,
    DatasetDataLoad = 1,
    PBIUpdate = 2,
    Finalization = 3,
}

export interface UserDatasetRefreshLogSubStageDto {
    type?: UserDatasetSubStageType;
    status?: UserDatasetRefreshStatus;
    startedDateTimeUTC?: string | undefined;
    finishedDateTimeUTC?: string | undefined;
    error?: string | undefined;
}

export enum UserDatasetSubStageType {
    Connecting = 0,
    Executing = 1,
    DataStore = 2,
}

export interface AddOrUpdateUserDatasetDto {
    id?: number;
    name?: string | undefined;
    cacheDuration?: string | undefined;
    content?: UserDatasetContentDto | undefined;
    initialModelFromUserDatasetId?: number | undefined;
}

export interface EnsureDataAvailableResult {
    userDatasetId?: number;
    state?: EnsureDataAvailableState;
    jobId?: number | undefined;
}

export enum EnsureDataAvailableState {
    DataAvailable = 0,
    RefreshRunning = 1,
    RefreshFailed = 2,
    UserDatasetNull = 3,
}

export interface UserDatasetRefreshDto {
    lastRefreshed?: string | undefined;
    refreshDuration?: string | undefined;
    cacheDuration?: string | undefined;
}

export interface StoredUserDatasetValidationStateDto {
    userDatasetId?: number;
    version?: number;
    timestamp?: string;
    result?: UserDatasetValidationResultDto | undefined;
}

export interface UserDatasetValidationResultDto {
    parts?: UserDatasetValidationResultPartDto[] | undefined;
    type?: UserDatasetValidationResultType;
    isValid?: boolean;
}

export interface UserDatasetValidationResultPartDto {
    type?: UserDatasetValidationResultType;
    datasetIssues?: UserDatasetIssueDto[] | undefined;
    inputs?: { [key: string]: UserDatasetIssueDto[]; } | undefined;
    fields?: { [key: string]: UserDatasetIssueDto[]; } | undefined;
}

export enum UserDatasetValidationResultType {
    Valid = 0,
    ValidWithIssues = 1,
    Invalid = 2,
}

export interface UserDatasetIssueDto {
    severity?: UserDatasetIssueSeverity;
    type?: UserDatasetIssueType;
    context?: any | undefined;
    description?: string | undefined;
}

export enum UserDatasetIssueSeverity {
    Info = 0,
    Warning = 1,
    Error = 2,
}

export enum UserDatasetIssueType {
    GenericIssue = 0,
    InvalidDatasetTemplate = 1,
    DatasetNotAvailable = 2,
    MissingRequiredElement = 3,
    ExtraneousElement = 4,
    DuplicateElement = 5,
    ElementNotEditable = 6,
    InvalidJoinField = 7,
    MissingJoinField = 8,
}

export enum UserDatasetProfileFileType {
    Json = 0,
    Csv = 1,
}

export interface ClientCustomizationDataDto {
    enabled?: boolean;
    logo?: ClientCustomizationLogoUrlDto | undefined;
    logoText?: string | undefined;
    font?: string | undefined;
    applyEmail?: boolean;
    applyPdf?: boolean;
}

export interface ClientCustomizationLogoUrlDto {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    url?: string | undefined;
}

export interface ListOrganisationDto {
    id?: number;
    name?: string | undefined;
    longName?: string | undefined;
    defaults?: AppSettingsDto | undefined;
    products?: OrganisationProductDto[] | undefined;
    productUpgrades?: ProductUpgradeDto[] | undefined;
}

export interface OrganisationProductDto {
    productVersionId?: number;
    maxSourceVersion?: string | undefined;
}

export interface ProductUpgradeDto {
    id?: number;
}

export interface SpendPeriodDto {
    year?: number;
    month?: number;
    startDateUtc?: string;
    endDateUtc?: string;
}

export interface SystemInfoDto {
    insightsVersion?: string | undefined;
    companyName?: string | undefined;
    companyLongName?: string | undefined;
    copyrightUrl?: string | undefined;
}

export interface LicenseInfoDto {
    insightsVersion?: string | undefined;
    licenseItems?: LicenseItemDto[] | undefined;
}

export interface LicenseItemDto {
    packageName?: string | undefined;
    packageVersion?: string | undefined;
    copyright?: string | undefined;
    licenseType?: string | undefined;
    licenseUrl?: string | undefined;
}

export interface SchedulerConfig {
    scheduler?: boolean;
    emailFromAddress?: string | undefined;
}

export interface ListScheduleDto {
    id?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    name?: string | undefined;
    type?: ScheduleType;
    exportOptions?: ScheduleExportOptionsDto | undefined;
    shared?: boolean;
    emailRecipients?: number | undefined;
    enabled?: boolean | undefined;
    recurring?: boolean;
    scheduleDay?: ScheduleDay | undefined;
    scheduleMonth?: ScheduleMonth | undefined;
    scheduleDateTime?: string | undefined;
    scheduleTimezoneIana?: string | undefined;
    isRunning?: boolean | undefined;
    lastRun?: string | undefined;
    nextRun?: string | undefined;
    lastStatus?: ScheduleStatus;
    lastStatusText?: string | undefined;
    fileSize?: number | undefined;
    storedFileExpiry?: string | undefined;
    itemDetails?: ScheduleItemDetailsDto | undefined;
    favourite?: boolean;
}

export enum ScheduleType {
    Dashboard = 0,
    Pivot = 1,
}

export interface ScheduleExportOptionsDto {
    fileType?: VisualExportFileFormat;
    tableFormat?: ExportVisualDataTableFormat | undefined;
    style?: VisualExportStyle | undefined;
    chartImage?: boolean | undefined;
    paperSize?: PdfPaperSize | undefined;
    includeHeader?: boolean | undefined;
    includeFooter?: boolean | undefined;
}

export enum VisualExportFileFormat {
    Csv = 0,
    Json = 1,
    Excel = 4,
    Pdf = 5,
    Png = 6,
}

export enum ExportVisualDataTableFormat {
    Default = 0,
    PivotTable = 1,
}

export enum VisualExportStyle {
    None = 0,
    Default = 1,
    Optimize = 2,
}

export enum ScheduleDay {
    EveryDay = 0,
    EveryMonday = 1,
    EveryTuesday = 2,
    EveryWednesday = 3,
    EveryThursday = 4,
    EveryFriday = 5,
    EverySaturday = 6,
    EverySunday = 7,
    FirstDayOfTheMonth = 8,
    LastDayOfTheMonth = 9,
    FirstWeekdayOfTheMonth = 10,
    LastWeekdayOfTheMonth = 11,
    FirstMondayOfTheMonth = 12,
    FirstTuesdayOfTheMonth = 13,
    FirstWednesdayOfTheMonth = 14,
    FirstThursdayOfTheMonth = 15,
    FirstFridayOfTheMonth = 16,
    FirstSaturdayOfTheMonth = 17,
    FirstSundayOfTheMonth = 18,
    LastMondayOfTheMonth = 19,
    LastTuesdayOfTheMonth = 20,
    LastWednesdayOfTheMonth = 21,
    LastThursdayOfTheMonth = 22,
    LastFridayOfTheMonth = 23,
    LastSaturdayOfTheMonth = 24,
    LastSundayOfTheMonth = 25,
    Day2OfTheMonth = 26,
    Day3OfTheMonth = 27,
    Day4OfTheMonth = 28,
    Day5OfTheMonth = 29,
    Day6OfTheMonth = 30,
    Day7OfTheMonth = 31,
    Day8OfTheMonth = 32,
    Day9OfTheMonth = 33,
    Day10OfTheMonth = 34,
    Day11OfTheMonth = 35,
    Day12OfTheMonth = 36,
    Day13OfTheMonth = 37,
    Day14OfTheMonth = 38,
    Day15OfTheMonth = 39,
    Day16OfTheMonth = 40,
    Day17OfTheMonth = 41,
    Day18OfTheMonth = 42,
    Day19OfTheMonth = 43,
    Day20OfTheMonth = 44,
    Day21OfTheMonth = 45,
    Day22OfTheMonth = 46,
    Day23OfTheMonth = 47,
    Day24OfTheMonth = 48,
    Day25OfTheMonth = 49,
    Day26OfTheMonth = 50,
    Day27OfTheMonth = 51,
    Day28OfTheMonth = 52,
    Day29OfTheMonth = 53,
    Day30OfTheMonth = 54,
    Day31OfTheMonth = 55,
}

export enum ScheduleMonth {
    EveryMonth = 0,
    FirstMonthOfEveryQuarter = 1,
    LastMonthOfEveryQuarter = 2,
    January = 3,
    February = 4,
    March = 5,
    April = 6,
    May = 7,
    June = 8,
    July = 9,
    August = 10,
    September = 11,
    October = 12,
    November = 13,
    December = 14,
}

export enum ScheduleStatus {
    Pending = 0,
    Running = 1,
    Failed = 2,
    Succeeded = 3,
}

export interface ScheduleItemDetailsDto {
    name?: string | undefined;
    description?: string | undefined;
    owner?: string | undefined;
    deleted?: boolean;
    shared?: boolean;
    fromLibrary?: boolean;
    notSharedOrLibrary?: boolean;
    subtitle?: string | undefined;
}

export interface ScheduleDto {
    id?: number;
    organisationId?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    name?: string | undefined;
    type?: ScheduleType;
    exportOptions?: ScheduleExportOptionsDto | undefined;
    shared?: boolean;
    jobId?: number | undefined;
    lastRun?: string | undefined;
    nextRun?: string | undefined;
    lastStatus?: ScheduleStatus;
    lastStatusText?: string | undefined;
    data?: ScheduleDataDto | undefined;
    runDisabled?: boolean;
}

export interface ScheduleDataDto {
    visualOrDashboardId?: number | undefined;
    storedFileId?: number | undefined;
    storedFileExpiry?: string;
    fileSize?: number | undefined;
    daysToStore?: number | undefined;
    enabled?: boolean;
    emailRecipientsCount?: number | undefined;
    recipientEmails?: string[] | undefined;
    deliverEmpty?: boolean;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    confirmationEmail?: string | undefined;
    replyToEmail?: string | undefined;
    fileUploadEnabled?: boolean;
    fileUploadParams?: FileUploadParamsDto | undefined;
    recurring?: boolean;
    scheduleHour?: number | undefined;
    scheduleMinute?: number | undefined;
    scheduleTimezoneIana?: string | undefined;
    scheduleDay?: ScheduleDay | undefined;
    scheduleMonth?: ScheduleMonth | undefined;
    scheduleDate?: string | undefined;
    confirmationEnabled?: boolean;
    otherAdminsViewEdit?: boolean;
    itemDetails?: ScheduleItemDetailsDto | undefined;
    refreshCache?: boolean | undefined;
}

export interface FileUploadParamsDto {
    configId?: number;
    fileName?: string | undefined;
    relativeDirectory?: string | undefined;
    conflictBehaviour?: FileUploadConflictBehaviour | undefined;
}

export enum FileUploadConflictBehaviour {
    Override = 0,
    Skip = 1,
    Error = 2,
    CreateCopy = 3,
}

export interface AddOrUpdateScheduleDto {
    id?: number;
    organisationId?: number;
    name?: string | undefined;
    type?: ScheduleType;
    exportOptions?: ScheduleExportOptionsDto | undefined;
    shared?: boolean;
    data?: ScheduleDataDto | undefined;
    runDisabled?: boolean;
}

export interface ScheduleIsDuplicateDto {
    isDuplicate?: boolean;
}

export interface ScheduleDuplicateCheckDto {
    id?: number;
    name?: string | undefined;
}

export interface UserScheduleDto {
    scheduleId?: number;
    favourite?: boolean;
}

export interface AssetLockDto {
    contentTypeName?: string | undefined;
    contentId?: number;
    timestamp?: string;
    contentName?: string | undefined;
    lockedByUserId?: number;
    lockedBy?: string | undefined;
}

export interface BusinessUserStateDto {
    homeContentType?: EmbedContentType;
    homeContentId?: number | undefined;
}

export enum EmbedContentType {
    Dashboard = 0,
    Visual = 1,
}

export interface NotificationDto {
    id?: number;
    priority?: number;
    pending?: boolean;
    timeCreated?: string | undefined;
    timeRequested?: string | undefined;
    content?: NotificationContentBase | undefined;
    category?: NotificationCategory;
}

export interface NotificationContentBase {
    type?: NotificationType;
}

export enum NotificationType {
    PivotExtDatasetLoaded = 0,
    DashboardExtDatasetLoaded = 1,
    SchedulerReportFinished = 2,
    AssetUnlocked = 3,
}

export interface ScheduleReportFinishedCompleteNotification extends NotificationContentBase {
    id?: number;
    scheduleName?: string | undefined;
    succesful?: boolean | undefined;
}

export interface PivotExtDatasetLoadedNotification extends NotificationContentBase {
    id?: number;
    pivotName?: string | undefined;
    succesful?: boolean | undefined;
}

export interface DashboardExtDatasetLoadedNotification extends NotificationContentBase {
    id?: number;
    dashboardName?: string | undefined;
    succesful?: boolean | undefined;
}

export interface AssetUnlockedNotification extends NotificationContentBase {
    id?: number;
    assetLockType?: string | undefined;
    assetName?: string | undefined;
}

export interface NotificationInfoDto {
    pendingToasts?: NotificationToastDto[] | undefined;
    notifications?: NotificationDto[] | undefined;
    scheduleNotifications?: number;
}

export interface NotificationToastDto {
    id?: number;
    priority?: number;
    content?: NotificationContentBase | undefined;
    category?: NotificationCategory;
}

export interface AppUserDto extends UserDto {
    region?: string | undefined;
    ownerOrganisationId?: number;
    ownerOrganisationDisplayName?: string | undefined;
    organisationId?: number;
    organisationDisplayName?: string | undefined;
    features?: UserAppFeaturesDto | undefined;
    impersonation?: ImpersonationDto | undefined;
}

export interface ImpersonationDto {
    impersonator?: ImpersonationUserDetailsDto | undefined;
    target?: ImpersonationUserDetailsDto | undefined;
}

export interface ImpersonationUserDetailsDto {
    id?: number;
    organisationId?: number;
    organisation?: string | undefined;
    role?: UserRole;
    name?: string | undefined;
}

export interface ListUserDto {
    id?: number;
    username?: string | undefined;
    role?: UserRole;
    settings?: AppSettingsDto | undefined;
}

export interface ListOrganisationUserDto {
    id?: number;
    username?: string | undefined;
    role?: UserRole;
}

export interface UserQueryEditorPreferenceDto {
    indentGuides?: boolean;
    showLineNumbers?: boolean;
    showWhitespace?: boolean;
    wordWrap?: boolean;
    darkTheme?: boolean;
    zoom?: number;
}

export interface UserStateDto {
    firstHomeDashboardSelected?: boolean;
    lastViewedDashboardId?: number | undefined;
    lastViewedVisualId?: number | undefined;
    defaultPdfPaperSize?: PdfPaperSize;
}

export interface PivotStudioConfig {
    advancedDatasets?: boolean;
    calculatedFields?: boolean;
    disableAggregationsForNonMeasureGroups?: boolean;
    measureGroups?: PivotStudioMeasureGroupConfig[] | undefined;
    fields?: PivotStudioModelFieldConfig[] | undefined;
    extDatasets?: PivotStudioExtDatasetConfig[] | undefined;
}

export interface PivotStudioMeasureGroupConfig {
    dataSchemaName?: string | undefined;
    groupName?: string | undefined;
    disabledAggregationFields?: string[] | undefined;
}

export interface PivotStudioModelFieldConfig {
    table?: string | undefined;
    field?: string | undefined;
    aggregationFunctions?: AggregationFunctions;
    defaultMeasureAggregationFunction?: DataAggregationFunction;
}

export enum AggregationFunctions {
    Default = 0,
    NumericBoolean = 1,
    IdField = 2,
}

export interface PivotStudioExtDatasetConfig {
    datasetName?: string | undefined;
    fields?: PivotStudioModelFieldConfig[] | undefined;
}

export interface CustomFieldFunction {
    hidden?: boolean;
    category?: string | undefined;
    name?: string | undefined;
    description?: string[] | undefined;
    returnType?: ValueDataType;
    returnTypeMode?: CustomFieldFunctionReturnTypeMode;
    arguments?: CustomFieldFunctionArgument[] | undefined;
    minArguments?: number;
    maxArguments?: number | undefined;
    commonlyUsed?: boolean;
    syntaxFormat?: string | undefined;
    aggregatesFields?: boolean;
    aggregationFunction?: DataAggregationFunction | undefined;
    convertArguments?: boolean;
    dataQuerySyntaxFormat?: string | undefined;
}

export enum CustomFieldFunctionReturnTypeMode {
    ReturnType = 0,
    Args_First = 1,
    Args_Last = 2,
    Args_All = 4,
    Args_IgnoreFirst = 8,
    NonNull = 16,
    LeastNullable = 32,
}

export interface CustomFieldFunctionArgument {
    name?: string | undefined;
    description?: string[] | undefined;
    type?: ValueDataType;
    typeMustMatch?: boolean;
    measureArgument?: boolean;
}

export interface UserVisualDto {
    visualId?: number;
    favourite?: boolean | undefined;
    home?: boolean | undefined;
}

export interface UserVisualStateDto {
    pivotUnfreezeRows?: boolean;
}

export interface ListItemsForUserRequestDto {
    organisationId?: number;
    userId?: number;
    includeLibrary?: boolean;
    includeShared?: boolean;
    includeSamples?: boolean;
    includeContent?: boolean;
}

export interface VisualDto {
    id?: number;
    organisationId?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    name?: string | undefined;
    description?: string | undefined;
    categoryIds?: number[] | undefined;
    sample?: boolean;
    fromLibrary?: boolean;
    shared?: boolean;
    content?: VisualContentDto | undefined;
    preferences?: VisualPreferencesDto | undefined;
    userDatasetId?: number | undefined;
    tempVisual?: boolean;
    appliedDynamicFilters?: AppliedDynamicFilters;
    userDatasetState?: UserDatasetState | undefined;
    userDatasetLatestRefreshResult?: UserDatasetRefreshStatus | undefined;
    userDatasetLatestRefreshResultTimestamp?: string | undefined;
}

export interface SetVisualRequestDto {
    visual?: AddOrUpdateVisualDto | undefined;
    updateUserDatasetRequest?: UpdateUserDatasetRequest | undefined;
}

export interface AddOrUpdateVisualDto {
    id?: number;
    organisationId?: number;
    createdBy?: string | undefined;
    schema?: SchemaTargetDto | undefined;
    name?: string | undefined;
    description?: string | undefined;
    categoryIds?: number[] | undefined;
    sample?: boolean;
    fromLibrary?: boolean;
    shared?: boolean;
    content?: VisualContentDto | undefined;
    preferences?: VisualPreferencesDto | undefined;
    userDatasetId?: number | undefined;
    tempVisual?: boolean;
}

export interface UpdateUserDatasetRequest {
    cacheDuration?: string | undefined;
}

export interface VisualUsageDto {
    inDashboard?: boolean;
    inSchedule?: boolean;
    published?: boolean;
    inSharedDashboard?: boolean;
    inScheduledDashboard?: boolean;
    inPublishedDashboard?: boolean;
}

export interface RelativeDateFilterRangeDto {
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export interface RelativeDateOrTimeValuesDto {
    operator?: RelativeDateOrTimeOperator;
    unitsCount?: number | undefined;
    unitType?: RelativeDateTimeFilterUnit;
    units2Count?: number | undefined;
    unit2Type?: RelativeDateTimeFilterUnit | undefined;
    includeToday?: boolean;
}

export interface CopyVisualDto {
    visualId?: number;
    copyContent?: boolean;
}

export interface CopyVisualsDto {
    visuals?: CopyVisualDto[] | undefined;
}

export interface ImportVisualDetailsDto {
    fileName?: string | undefined;
    visualName?: string | undefined;
    visualType?: string | undefined;
    schemaName?: string | undefined;
    typeSupported?: boolean;
}

export interface ImportVisualResultDto {
    fileName?: string | undefined;
    isSuccess?: boolean;
    diagnostics?: DiagnosticCollectionDto | undefined;
    visualId?: number | undefined;
    visualName?: string | undefined;
}

export interface DiagnosticCollectionDto {
    diagnostics?: DiagnosticDto[] | undefined;
    anyWarnings?: boolean;
    anyErrors?: boolean;
}

export interface DiagnosticDto {
    timestampUtc?: string;
    level?: DiagnosticLevel;
    message?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
    isWarning?: boolean;
    isError?: boolean;
}

export enum DiagnosticLevel {
    Debug = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
}

export interface VisualDownloadLinkDto {
    type?: VisualDownloadLinkType;
    url?: string | undefined;
}

export enum VisualDownloadLinkType {
    Csv = 0,
    Json = 1,
    TableauWDC = 2,
}

export enum VisualExportDataFormat {
    Csv = 0,
    Json = 1,
    TableauJson = 2,
    TableauStream = 3,
    Excel = 4,
}

export interface ExportVisualFileRequestDto {
    visualId?: number;
    filterOverrides?: FilterDto[] | undefined;
    fileName?: string | undefined;
    format?: VisualExportFileFormat;
    includeHeader?: boolean;
    includeFooter?: boolean;
    paperSize?: PdfPaperSize;
    customFields?: CustomFieldDto[] | undefined;
    renderUnshared?: boolean;
    tableFormat?: ExportVisualDataTableFormat;
    chartImage?: boolean;
    imageDpi?: number;
    style?: VisualExportStyle;
    locale?: string | undefined;
}

export interface ExportVisualDataStatusDto {
    status?: JobStatus;
    error?: string | undefined;
}

export interface ExportVisualDataResultDto {
    fileUrl?: string | undefined;
    fileName?: string | undefined;
}

export interface DataModelDto {
    sources?: DataSourceDto[] | undefined;
    relationships?: DataRelationshipDto[] | undefined;
}

export interface DataSourceDto {
    reference?: DataSourceReference | undefined;
    defaultFormats?: { [key in keyof typeof ValueDataType]?: DataFormat; } | undefined;
    defaultDisplayOptions?: { [key in keyof typeof ValueDataType]?: DataDisplayOptions; } | undefined;
    defaultAggregations?: { [key in keyof typeof ValueDataType]?: DataAggregationFunction; } | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
    tables?: DataTableDto[] | undefined;
    schemas?: DataSchemaDto[] | undefined;
}

export interface DataSourceReference {
    type?: DataSourceType;
}

export enum DataSourceType {
    Product = "Product",
    UserDataset = "UserDataset",
    ResultSet = "ResultSet",
}

export interface ProductDataSourceReference extends DataSourceReference {
    product?: string;
}

export interface UserDatasetDataSourceReference extends DataSourceReference {
    userDatasetId?: number;
}

export interface ResultSetDataSourceReference extends DataSourceReference {
    resultSetId?: string;
}

export interface DataFormat {
    numberRounding?: NumberRoundingDefinition | undefined;
    timestamp?: TimestampPrecision;
    treatNullAsBlank?: boolean;
}

export interface NumberRoundingDefinition {
    method: NumberRoundingMethod;
    precision?: number | undefined;
}

export enum TimestampPrecision {
    Default = "default",
    Milliseconds = "milliseconds",
    Seconds = "seconds",
    Minutes = "minutes",
    Hours = "hours",
    Day = "day",
    Month = "month",
    Year = "year",
}

export interface DataDisplayOptions {
    numberFormat?: DataNumberFormat;
    numberRounding?: NumberRoundingDefinition | undefined;
    showThousandSeparator?: boolean;
    significantDigitsOnly?: boolean;
    currency?: DataCurrencyDisplay;
    naNText?: string | undefined;
    positiveInfinityText?: string | undefined;
    negativeInfinityText?: string | undefined;
    timeFormat?: DataTimeFormat;
    dateFormat?: DataDateFormat;
    forceTwentyFourClock?: boolean;
    trueQueryExpr?: QueryExprSyntaxTree | undefined;
    falseQueryExpr?: QueryExprSyntaxTree | undefined;
    errorQueryExpr?: QueryExprSyntaxTree | undefined;
    nullQueryExpr?: QueryExprSyntaxTree | undefined;
    numericAggregationNullQueryExpr?: QueryExprSyntaxTree | undefined;
    formattingQueryExpr?: QueryExprSyntaxTree | undefined;
}

export enum DataNumberFormat {
    Default = "Default",
    Currency = "Currency",
    Scientific = "Scientific",
    Percentage = "Percentage",
    Full = "Full",
}

export interface QueryExprSyntaxTree {
    root?: QueryExprSyntax;
}

export interface QueryExprSyntax {
    kind?: QueryExprKind;
}

export enum QueryExprKind {
    Unary = "unary",
    Binary = "binary",
    FunctionCall = "func",
    Identifier = "ident",
    List = "list",
    Map = "map",
    Literal = "literal",
    Index = "index",
    Member = "member",
}

export interface BinarySyntax extends QueryExprSyntax {
    operator?: BinaryOperator;
    left?: QueryExprSyntax;
    right?: QueryExprSyntax;
}

export enum BinaryOperator {
    RaiseTo = "pow",
    Multiply = "mul",
    Divide = "div",
    Mod = "mod",
    Add = "add",
    Subtract = "sub",
    LessThan = "lt",
    GreaterThan = "gt",
    LessThanOrEqual = "lte",
    GreaterThanOrEqual = "gte",
    Equal = "eq",
    NotEqual = "neq",
    And = "and",
    Or = "or",
    Concat = "cat",
    With = "with",
    Without = "without",
    In = "in",
}

export interface FunctionCallSyntax extends QueryExprSyntax {
    functionName?: string;
    arguments?: QueryExprSyntax[];
}

export interface IdentifierSyntax extends QueryExprSyntax {
    value?: IdentifierValue;
}

export interface IdentifierValue {
    value?: string;
}

export interface IndexSyntax extends QueryExprSyntax {
    subject?: QueryExprSyntax;
    key?: QueryExprSyntax;
}

export interface ListSyntax extends QueryExprSyntax {
    items?: QueryExprSyntax[];
}

export interface LiteralSyntax extends QueryExprSyntax {
    type?: LiteralType;
}

export enum LiteralType {
    Null = "null",
    Boolean = "boolean",
    Integer = "int",
    Number = "number",
    Decimal = "decimal",
    String = "string",
    Date = "date",
    Time = "time",
    DateTime = "datetime",
}

export interface LiteralSyntaxOfBoolean extends LiteralSyntax {
    value?: boolean;
}

export interface BooleanLiteralSyntax extends LiteralSyntaxOfBoolean {
}

export interface LiteralSyntaxOfDateOnly extends LiteralSyntax {
    value?: string;
}

export interface DateLiteralSyntax extends LiteralSyntaxOfDateOnly {
}

export interface LiteralSyntaxOfDateTimeOffset extends LiteralSyntax {
    value?: string;
}

export interface DateTimeLiteralSyntax extends LiteralSyntaxOfDateTimeOffset {
}

export interface LiteralSyntaxOfDecimal extends LiteralSyntax {
    value?: number;
}

export interface DecimalLiteralSyntax extends LiteralSyntaxOfDecimal {
}

export interface LiteralSyntaxOfLong extends LiteralSyntax {
    value?: number;
}

export interface IntegerLiteralSyntax extends LiteralSyntaxOfLong {
}

export interface LiteralSyntaxOfObject extends LiteralSyntax {
    value?: any | undefined;
}

export interface NullLiteralSyntax extends LiteralSyntaxOfObject {
}

export interface LiteralSyntaxOfDouble extends LiteralSyntax {
    value?: number;
}

export interface NumberLiteralSyntax extends LiteralSyntaxOfDouble {
}

export interface LiteralSyntaxOfString extends LiteralSyntax {
    value?: string | undefined;
}

export interface StringLiteralSyntax extends LiteralSyntaxOfString {
}

export interface LiteralSyntaxOfTimeOnly extends LiteralSyntax {
    value?: string;
}

export interface TimeLiteralSyntax extends LiteralSyntaxOfTimeOnly {
}

export interface MapSyntax extends QueryExprSyntax {
    items?: MapSyntaxItem[];
}

export interface MapSyntaxItem {
    key?: IdentifierSyntax;
    value?: QueryExprSyntax;
}

export interface MemberSyntax extends QueryExprSyntax {
    subject?: QueryExprSyntax;
    key?: IdentifierValue;
}

export interface UnarySyntax extends QueryExprSyntax {
    operator?: UnaryOperator;
    right?: QueryExprSyntax;
}

export enum UnaryOperator {
    Plus = "plus",
    Minus = "minus",
    Not = "not",
}

export interface DataTableDto {
    name?: string;
    query?: DataTableQuery | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
    fields?: DataFieldDto[] | undefined;
}

export interface DataTableQuery {
    type?: DataTableQueryType;
}

export enum DataTableQueryType {
    CalculatedTable = "CalculatedTable",
    NamedTable = "NamedTable",
    Sql = "Sql",
}

export interface CalculatedDataTableQuery extends DataTableQuery {
}

export interface NamedTableDataTableQuery extends DataTableQuery {
    table?: string;
    schema?: string | undefined;
}

export interface SqlDataTableQuery extends DataTableQuery {
    expression?: string;
}

export interface DataFieldDto {
    name?: string;
    type?: DataFieldType;
    sourceKey?: any | undefined;
    valueSource?: DataFieldSource | undefined;
    indexed?: boolean;
    hasErrors?: boolean;
    removed?: boolean;
    dataType?: ValueDataType;
    isNullable?: boolean;
    format?: DataFormat | undefined;
    isValueAggregated?: boolean;
    sortByValueSource?: DataFieldSource | undefined;
    defaultSort?: DataSortMode;
    defaultUsage?: DataFieldUsage | undefined;
    defaultAggregation?: DataAggregationFunction | undefined;
    mustHaveAggregation?: boolean;
    displayOptions?: DataDisplayOptions | undefined;
    usageHints?: DataFieldUsageHints | undefined;
    currencyVariants?: { [key: string]: DataFieldReference; } | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
    children?: DataFieldDto[] | undefined;
}

export enum DataFieldType {
    Model = "Model",
    CurrencyVariant = "CurrencyVariant",
    CustomField = "CustomField",
    UDF = "UDF",
}

export interface DataFieldSource {
    type?: DataFieldSourceType;
}

export enum DataFieldSourceType {
    TableColumn = "TableColumn",
    InsightsQuerySyntax = "InsightsQuerySyntax",
    QueryExprSyntax = "QueryExprSyntax",
    SqlExpression = "SqlExpression",
}

export interface TableColumnDataFieldSource extends DataFieldSource {
    column?: ColumnReference;
}

export interface ColumnReference {
    table: string;
    column: string;
}

export interface InsightsQuerySyntaxDataFieldSource extends DataFieldSource {
    expr?: string | undefined;
}

export interface QueryExprSyntaxDataFieldSource extends DataFieldSource {
    syntax?: QueryExprSyntaxTree | undefined;
}

export interface SqlExpressionDataFieldSource extends DataFieldSource {
    sql?: string | undefined;
}

export enum DataSortMode {
    Unset = "Unset",
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface DataFieldReference {
    table?: DataTableReference;
    path?: string[];
}

export interface DataTableReference {
    source?: DataSourceReference | undefined;
    table?: string;
}

export interface DataSchemaDto {
    displayName?: string | undefined;
    reference?: DataSchemaReference | undefined;
    factTable?: string | undefined;
    supportsCurrencyConversion?: boolean;
    itemDisplay?: ItemDisplayOptions | undefined;
    itemGroups?: DataSchemaItemGroupDto[] | undefined;
    dataQueryModelTimestamp?: string | undefined;
    dataQueryModelId?: string | undefined;
}

export interface DataSchemaReference {
    type?: DataSchemaType;
    name?: string;
}

export enum DataSchemaType {
    Core = "Core",
    VisualCustomFields = "VisualCustomFields",
}

export interface CoreDataSchemaReference extends DataSchemaReference {
}

export interface VisualCustomFieldsDataSchemaReference extends DataSchemaReference {
    schema?: DataSchemaReference | undefined;
    visualId?: number;
}

export interface ItemDisplayOptions {
    order?: number;
    hidden?: boolean;
    minUserRole?: UserRole | undefined;
    description?: RichTextValue;
    tooltip?: RichTextValue;
    selectorDisplayName?: string | undefined;
}

export interface RichTextValue {
    type?: RichTextType;
    content?: string | undefined;
}

export enum RichTextType {
    String = "String",
    HTML = "HTML",
    Markdown = "Markdown",
}

export interface DataSchemaItemGroupDto {
    name?: string;
    kind?: DataSchemaItemGroupKind;
    itemDisplay?: ItemDisplayOptions | undefined;
    items?: DataSchemaItemDto[] | undefined;
}

export enum DataSchemaItemGroupKind {
    Default = 0,
    Measures = 1,
    CalculatedFields = 2,
}

export interface DataSchemaItemDto {
    name?: string;
    field?: DataFieldReference;
    itemDisplay?: ItemDisplayOptions | undefined;
    children?: DataSchemaItemDto[] | undefined;
}

export interface DataRelationshipDto {
    from?: DataFieldReference;
    to?: DataFieldReference;
    cardinality?: RelationshipCardinality;
    nonNull?: boolean;
}

export enum RelationshipCardinality {
    OneToOne = "oneToOne",
    OneToMany = "oneToMany",
    ManyToMany = "manyToMany",
    ManyToOne = "manyToOne",
}

export interface OrganisationDataModelDto {
    organisationId?: number;
    modelDto?: DataModelDto | undefined;
    timestamp?: string | undefined;
}

export interface DataRelationshipMappingDto {
    timestamp?: number;
    products?: DataRelationshipMappingProductDto[] | undefined;
}

export interface DataRelationshipMappingProductDto {
    productId?: number;
    productName?: string;
    items?: DataRelationshipMappingProductItemDto[] | undefined;
}

export interface DataRelationshipMappingProductItemDto {
    schemaName?: string;
    groupName?: string;
    itemName?: string;
    tagName?: string | undefined;
}

export interface ListEnterpriseUserDto {
    employeeCode?: string | undefined;
    displayName?: string | undefined;
}

export interface EnterpriseUserDataDto {
    userType?: EnterpriseUserType;
    spend?: EnterpriseUserSpendDataDto | undefined;
}

export enum EnterpriseUserType {
    User = 0,
    ReportingManager = 1,
    None = 2,
}

export interface EnterpriseUserSpendDataDto {
    userType?: SpendUserType;
    employeeCode?: string | undefined;
    departmentNames?: string[] | undefined;
}

export enum SpendUserType {
    RollupManager = 0,
    DeptManager = 1,
    RegularUser = 2,
}

export interface ListPublishedReportDto {
    organisationId?: number;
    id?: number;
    createdById?: number;
    createdBy?: string | undefined;
    createdDate?: string;
    updatedBy?: string | undefined;
    updatedDate?: string;
    name?: string | undefined;
    enabled?: boolean;
    status?: PublishedReportStatus;
    isDefault?: boolean;
    item?: ListPublishedReportItemDetailsDto | undefined;
}

export enum PublishedReportStatus {
    ReportingManagers = 0,
    UsersAndReportingManagers = 1,
}

export interface ListPublishedReportItemDetailsDto {
    type?: PublishedReportItemType | undefined;
    name?: string | undefined;
    deleted?: boolean;
    fromLibrary?: boolean;
    createdBy?: string | undefined;
    shared?: boolean;
    visualCount?: number;
    appliedDynamicFilters?: AppliedDynamicFilters;
    dashboardFilteringStatus?: DashboardDynamicFilteringStatus;
}

export enum PublishedReportItemType {
    Dashboard = 0,
    Visual = 1,
}

export interface ListPublishedReportForBusinessUserDto {
    publishedTo?: PublishedReportStatus;
    itemType?: PublishedReportItemType;
    itemId?: number;
    itemName?: string | undefined;
    preview?: ContentPreviewDetailsDto | undefined;
}

export interface ContentPreviewDetailsDto {
    previewType?: ContentPreviewType;
}

export enum ContentPreviewType {
    Visual = 0,
    Dashboard = 1,
}

export interface VisualPreviewDetailsDto extends ContentPreviewDetailsDto {
    chartType?: string | undefined;
}

export interface DashboardPreviewDetailsDto extends ContentPreviewDetailsDto {
    type?: DashboardType;
    layout?: string | undefined;
    visuals?: DashboardVisualDetailsDto[] | undefined;
}

export interface PublishedReportDto {
    id?: number;
    createdById?: number;
    createdBy?: string | undefined;
    createdDate?: string;
    updatedDate?: string;
    organisationId?: number;
    name?: string | undefined;
    enabled?: boolean;
    item?: PublishedReportItemDto | undefined;
    itemDeleted?: boolean;
    itemShared?: boolean;
    itemFromLibrary?: boolean;
    itemCreatedBy?: string | undefined;
    status?: PublishedReportStatus;
    isDefault?: boolean;
}

export interface PublishedReportItemDto {
    type?: PublishedReportItemType;
}

export interface PublishedReportDashboardItemDto extends PublishedReportItemDto {
    dashboardId?: number;
}

export interface PublishedReportVisualItemDto extends PublishedReportItemDto {
    visualId?: number;
}

export interface AddOrUpdatePublishedReportDto {
    id?: number;
    name?: string | undefined;
    enabled?: boolean;
    item?: PublishedReportItemDto | undefined;
    status?: PublishedReportStatus;
}

export interface PublishedReportDuplicateCheckDto {
    name?: string | undefined;
    reportId?: number | undefined;
}

export interface UserPublishedReportStateDto {
    publishedReportId?: number;
    favourite?: boolean;
}

export interface SetPublishedReportIsDefaultDto {
    publishedReportId?: number;
    isDefault?: boolean;
}

export interface DefaultPublishedReportStateDto {
    publishedReportId?: number;
    deleted?: boolean;
    enabled?: boolean;
}

export interface ExecuteDataQueryResponse {
    queryId?: string;
    elements?: ExecuteDataQueryElement[] | undefined;
    source?: DataSourceReference | undefined;
}

export interface ExecuteDataQueryElement {
    resultSetIndex?: number;
    elementName?: string | undefined;
    field?: VisualFieldDto | undefined;
    target?: SchemaFieldTargetDto | undefined;
    dataType?: ValueDataType;
    isAggregated?: boolean;
    displayOptions?: DataDisplayOptions | undefined;
    displayName?: string | undefined;
    usage?: ExecuteDataQueryElementUsage;
    baseElementName?: string | undefined;
}

export enum ExecuteDataQueryElementUsage {
    Grouping = 0,
    Measure = 1,
    Sorting = 2,
    Other = 3,
}

export interface ExecuteDataQueryRequest {
    schema?: SchemaTargetDto | undefined;
    visualId?: number | undefined;
    visualName?: string | undefined;
    content?: ExecuteDataQueryRequestVisualContent | undefined;
    now?: string | undefined;
    userNow?: string | undefined;
    stream?: boolean;
    spendExtension?: ExecuteDataQuerySpendExtension | undefined;
    ignoreRowLimit?: boolean;
    rowLimit?: number | undefined;
    recordPlan?: boolean;
}

export interface ExecuteDataQueryRequestVisualContent {
    visual?: VisualContentDto | undefined;
    filterGroups?: FilterGroupDto[] | undefined;
}

export interface FilterGroupDto {
    operator: AdvancedFilterLogicalOperator;
    filters: FilterDto[];
}

export interface ExecuteDataQuerySpendExtension {
    countryID?: string | undefined;
    spendPeriod?: SpendPeriodDto | undefined;
}

export interface StreamedExecuteDataQueryRequest {
    queryId?: string;
    elements?: ExecuteDataQueryElement[] | undefined;
    url?: ExecuteUrl;
}

export interface ExecuteUrl {
    method?: string | undefined;
    headers?: { [key: string]: string; } | undefined;
    url?: string | undefined;
    body?: string | undefined;
}

export interface JsonRecord {
}

export interface RequestBase extends JsonRecord {
    correlationId?: string | undefined;
}

export interface QueryRequestBase extends RequestBase {
    queryId: string;
}

export interface CancelQueryRequest extends QueryRequestBase {
}

export interface ResponseBase extends JsonRecord {
    correlationId?: string | undefined;
}

export interface QueryResponseBase extends ResponseBase {
    queryId: string;
}

export interface GetQueryStateResponse extends QueryResponseBase {
    status: QueryStatus;
    queuedAt?: string | undefined;
    startedAt?: string | undefined;
    finishedAt?: string | undefined;
    cancelledAt?: string | undefined;
    detail?: string | undefined;
    error?: ErrorDetails | undefined;
    result?: GetQueryResultResponse | undefined;
}

export enum QueryStatus {
    Pending = "pending",
    Queued = "queued",
    Executing = "executing",
    Success = "success",
    Failed = "failed",
    Expired = "expired",
    Cancelled = "cancelled",
}

export interface ErrorDetails extends JsonRecord {
    title?: string | undefined;
    detail?: string | undefined;
    exception?: string | undefined;
    svcRegion?: number | undefined;
    svcMachine?: number | undefined;
    traceId?: string | undefined;
    correlationId?: string | undefined;
}

export interface GetQueryResultResponse extends QueryResponseBase {
    resultSets: ResultSetDefinition[];
}

export interface ResultSetDefinition extends JsonRecord {
    id: string;
    createdAt?: string;
    dataStore?: string;
    dataTable?: string | undefined;
    loadedAt?: string | undefined;
    expiresAt?: string | undefined;
    elements: ResultSetElementDefinition[];
    status?: ResultSetStatus;
    rowCount?: number;
    exceededRowCountLimit?: boolean;
    compression?: ResultSetCompression;
    error?: ErrorDetails | undefined;
}

export interface ResultSetElementDefinition extends JsonRecord {
    name: string;
    format: ValueFormatDefinition;
    usage?: ResultSetElementUsage | undefined;
    indexed?: boolean;
    dataColumn?: string;
    dataIndex?: number;
    sourceColumn?: string;
}

export interface ValueFormatDefinition extends JsonRecord {
    type: ValueDataType;
    nullable?: boolean;
}

export interface NumericFormatDefinition extends ValueFormatDefinition {
    rounding?: NumberRoundingDefinition | undefined;
}

export interface TextFormatDefinition extends ValueFormatDefinition {
    nullIsBlank?: boolean;
}

export interface TimestampFormatDefinition extends ValueFormatDefinition {
    timeZone?: string | undefined;
    precision?: TimestampPrecision;
}

export enum ResultSetElementUsage {
    None = "none",
    GroupingField = "groupingField",
    Aggregation = "aggregation",
}

export enum ResultSetStatus {
    Pending = "pending",
    Loading = "loading",
    Loaded = "loaded",
    Failed = "failed",
    Expired = "expired",
}

export enum ResultSetCompression {
    Uncompressed = "uncompressed",
    Compressed = "compressed",
}

export interface GetQueryStateRequest extends QueryRequestBase {
}

export interface GetQueryResultRequest extends QueryRequestBase {
}

export interface GetResultSetDataUrlResponse {
    method?: string | undefined;
    url?: string | undefined;
    headers?: { [key: string]: string; } | undefined;
}

export interface GetResultSetDataUrlRequest {
    queryId?: string;
    resultSetId?: string;
}

export interface StreamedResultSetDataQueryRequest {
    queryId?: string;
    resultSetId?: string;
    url?: ExecuteUrl2;
}

export interface ExecuteUrl2 {
    method?: string | undefined;
    headers?: { [key: string]: string; } | undefined;
    url?: string | undefined;
    body?: string | undefined;
}

export interface ResultSetDataQueryRequest {
    queryId?: string;
    resultSetId?: string;
    query?: QueryDefinition | undefined;
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    visualName?: string | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export interface QueryDefinition extends JsonRecord {
    context?: QueryContextDefinition;
    fields?: QueryFieldDefinition[];
    measures?: QueryMeasureDefinition[];
    filters?: QueryFilterDefinition[];
    order?: QueryOrderDefinition[];
    offset?: QueryOffsetDefinition | undefined;
    model?: ModelDefinition | undefined;
    skipIndexes?: boolean;
    isolationLevel?: QueryIsolationLevel | undefined;
}

export interface QueryContextDefinition extends JsonRecord {
    organisation: string;
    timestamp?: string | undefined;
    user?: UserDetailsDefinition | undefined;
    currency?: CurrencyDetailsDefinition | undefined;
    additionalProperties?: { [key: string]: any; };
}

export interface UserDetailsDefinition extends JsonRecord {
    name?: string;
    role?: InsightsUserRole | undefined;
    impersonator?: string | undefined;
    timestamp?: string | undefined;
    tz?: string | undefined;
}

export enum InsightsUserRole {
    ClientUser = 0,
    BusinessUser = 0,
    InsightsUser = 1,
    Admin = 1,
    ClientAdmin = 2,
    SupportAdmin = 2,
    InsightsAdmin = 3,
    SuperAdmin = 3,
    Developer = 4,
}

export interface CurrencyDetailsDefinition extends JsonRecord {
    name: string;
    code: string;
    symbol?: string | undefined;
}

export interface QueryElementDefinition extends JsonRecord {
    name: string;
    return?: boolean;
}

export interface QueryFieldDefinition extends QueryElementDefinition {
    source: FieldSourceDefinition;
    grouping: boolean;
}

export interface FieldSourceDefinition extends JsonRecord {
    type: FieldSourceType;
    format: ValueFormatDefinition;
}

export enum FieldSourceType {
    Column = "column",
    QueryExpr = "queryExpr",
    SqlExpression = "sqlExpr",
    SqlSyntax = "sqlSyntax",
}

export interface ColumnFieldSourceDefinition extends FieldSourceDefinition {
    column: ColumnReference;
}

export interface QueryExprFieldSourceDefinition extends FieldSourceDefinition {
    expr: QueryExprSyntaxTree;
    table?: string | undefined;
}

export interface SqlExpressionFieldSourceDefinition extends FieldSourceDefinition {
    sql: string;
}

export interface SqlSyntaxFieldSourceDefinition extends FieldSourceDefinition {
    syntax: SqlExpressionSyntax;
}

export interface SqlSyntax {
}

export interface SqlExpressionSyntax extends SqlSyntax {
}

export interface QueryMeasureDefinition extends QueryElementDefinition {
    source: MeasureSourceDefinition;
}

export interface MeasureSourceDefinition extends JsonRecord {
    type: MeasureSourceType;
    format: ValueFormatDefinition;
}

export enum MeasureSourceType {
    Column = "column",
    QueryExpr = "expr",
}

export interface ColumnMeasureSourceDefinition extends MeasureSourceDefinition {
    column: ColumnReference;
    measureType: CommonMeasureType;
}

export enum CommonMeasureType {
    Sum = "sum",
    Average = "avg",
    Median = "median",
    Minimum = "min",
    Maximum = "max",
    Count = "count",
    CountDistinct = "countDistinct",
    ApproximateCountDistinct = "approxCountDistinct",
    StandardDeviation = "stdDev",
    Variance = "variance",
    First = "first",
    Last = "last",
}

export interface QueryExprMeasureSourceDefinition extends MeasureSourceDefinition {
    expr: QueryExprSyntaxTree;
    schema?: string | undefined;
}

export interface QueryFilterDefinition extends JsonRecord {
    expr: QueryExprSyntaxTree;
}

export interface QueryOrderDefinition {
    items: QueryOrderByItem[];
    offset?: QueryOffsetDefinition | undefined;
}

export interface QueryOrderByItem {
    target: string;
    order: QueryOrderByDirection;
}

export enum QueryOrderByDirection {
    Ascending = "asc",
    Descending = "desc",
}

export interface QueryOffsetDefinition extends JsonRecord {
    skip?: number;
    take?: number;
}

export interface ModelDefinition extends JsonRecord {
    schemas: SchemaDefinition[];
    relationships: RelationshipDefinition[];
}

export interface ModelElementDefinition extends JsonRecord {
}

export interface ModelElementDefinitionOfSchemaName extends ModelElementDefinition {
    name: string;
}

export interface SchemaDefinition extends ModelElementDefinitionOfSchemaName {
    source: DataSourceDefinition;
    tables: TableDefinition[];
    factTable?: string | undefined;
}

export interface DataSourceDefinition extends JsonRecord {
    type: DataSourceType2;
}

export enum DataSourceType2 {
    InMemory = "inMemory",
    Metadata = "metadata",
    UserDatasets = "userDatasets",
    Product = "product",
    ResultSet = "resultSet",
    SqlDb = "sqlDb",
}

export interface InMemoryDataSourceDefinition extends DataSourceDefinition {
}

export interface MetadataDataSourceDefinition extends DataSourceDefinition {
}

export interface ProductDataSourceDefinition extends DataSourceDefinition {
    product: string;
}

export interface ResultSetDataSourceDefinition extends DataSourceDefinition {
    resultSetId: string;
}

export interface SqlDbDataSourceDefinition extends DataSourceDefinition {
    kind: string;
    target: SqlDatabaseTarget;
    connectionString?: string | undefined;
}

export interface SqlDatabaseTarget {
    server?: string;
    database?: string;
}

export interface UserDatasetsDataSourceDefinition extends DataSourceDefinition {
}

export interface ModelElementDefinitionOfTableName extends ModelElementDefinition {
    name: string;
}

export interface TableDefinition extends ModelElementDefinitionOfTableName {
    source: TableSourceDefinition;
    columns: ColumnDefinition[];
    keyColumns: string[];
}

export interface TableSourceDefinition extends JsonRecord {
    type: TableSourceType;
    hint?: TableSourceHint | undefined;
}

export enum TableSourceType {
    Calculated = "calc",
    Named = "name",
    QueryExpr = "expr",
    Sql = "sql",
}

export enum TableSourceHint {
    Inline = "inline",
    SmallLookup = "smallLookup",
    LargeLookup = "largeLookup",
    TempTable = "tempTable",
}

export interface CalculatedTableSourceDefinition extends TableSourceDefinition {
}

export interface NamedTableSourceDefinition extends TableSourceDefinition {
    table: string;
}

export interface QueryExprTableSourceDefinition extends TableSourceDefinition {
    expr: QueryExprSyntaxTree;
}

export interface SqlTableSourceDefinition extends TableSourceDefinition {
    sql: string;
}

export interface ModelElementDefinitionOfColumnName extends ModelElementDefinition {
    name: string;
}

export interface ColumnDefinition extends ModelElementDefinitionOfColumnName {
    source: FieldSourceDefinition;
    indexed?: boolean;
}

export interface ModelElementDefinitionOfRelationshipName extends ModelElementDefinition {
    name: string;
}

export interface RelationshipDefinition extends ModelElementDefinitionOfRelationshipName {
    from: ColumnReference;
    to: ColumnReference;
    behaviour?: RelationshipBehaviour;
}

export interface RelationshipBehaviour {
    cardinality: RelationshipCardinality;
    nonnull?: boolean;
}

export enum QueryIsolationLevel {
    ReadUncommitted = "readUncommitted",
    ReadCommitted = "readCommitted",
    RepeatableRead = "repeatableRead",
}

export interface GetQueryPlanResponse extends ResponseBase {
    queryId: string;
    plan: QueryPlanDefinition;
}

export interface QueryPlanDefinition extends JsonRecord {
    elements: QueryPlanElementDefinition[];
}

export interface QueryPlanElementDefinition extends JsonRecord {
    kind: QueryPlanElementKind;
}

export enum QueryPlanElementKind {
    SqlQueries = "sqlQueries",
}

export interface SqlQueriesQueryPlanElementDefinition extends QueryPlanElementDefinition {
    dataSource: DataSourceDefinition;
    sql: SqlQuery[];
}

export interface SqlQuery {
    commands: SqlQueryCommandData[];
}

export interface SqlQueryCommandData {
    type?: CommandType;
    text?: string;
    parameters?: SqlParameterData[];
    behaviour?: CommandBehavior;
    commandTimeout?: number;
    debugDisplay?: string | undefined;
}

export enum CommandType {
    Text = 1,
    StoredProcedure = 4,
    TableDirect = 512,
}

export interface SqlParameterData {
    name?: string;
    value?: any | undefined;
    dataTypeName?: string | undefined;
}

export enum CommandBehavior {
    Default = 0,
    SingleResult = 1,
    SchemaOnly = 2,
    KeyInfo = 4,
    SingleRow = 8,
    SequentialAccess = 16,
    CloseConnection = 32,
}

export interface GetQueryPlanRequest extends QueryRequestBase {
}

export interface AIAgentSession {
    id?: number;
    userId?: number;
    organisationId?: number;
    type?: string;
    status?: AIAgentSessionStatus;
    startedTimestamp?: string;
    updatedTimestamp?: string;
    completedTimestamp?: string | undefined;
    completeReason?: AIAgentSessionCompleteReason | undefined;
    hidden?: boolean;
}

export enum AIAgentSessionStatus {
    Started = 0,
    UserPrompt = 1,
    AgentResponding = 2,
    AgentResponded = 3,
    AgentResponseError = 4,
    Completed = 5,
}

export enum AIAgentSessionCompleteReason {
    CancelledByUser = 0,
    FinishedByUser = 1,
    FinishedByAgent = 2,
    TimedOut = 3,
    Error = 4,
}

export interface AIAgentSessionCreateRequest {
    type?: string;
    serializedData?: string | undefined;
}

export interface AIAgentSessionMessage {
    id?: number;
    timestamp?: string;
    type?: AIAgentSessionMessageType;
    content?: string | undefined;
    userMessage?: string | undefined;
    hasResult?: boolean;
    excludeFromAgentChat?: boolean;
}

export enum AIAgentSessionMessageType {
    ApplicationToUser = 0,
    UserPrompt = 1,
    ApplicationToAgent = 2,
    AgentResponse = 3,
    AgentResponseError = 4,
    UnexpectedError = 5,
    Debug = 6,
}

export interface AIAgentExecuteModel {
    accessToken?: string | undefined;
    lastUserMessageId?: number;
}

export interface CacheEntryDto {
    key?: string | undefined;
    type?: string | undefined;
    slidingExpiration?: string | undefined;
    absoluteExpiration?: string | undefined;
}

export interface ClearCacheKeysDto {
    items?: string[] | undefined;
}

export interface ClientCustomizationSettingsDto {
    imageName?: string | undefined;
    imageBlobUrl?: string | undefined;
    imageBlobFileId?: number | undefined;
    applyContentExports?: boolean;
    applyEmail?: boolean;
    font?: string | undefined;
}

export interface AppFeaturesDto {
    general?: GeneralFeaturesDto | undefined;
    visualRendering?: VisualRenderingFeaturesDto | undefined;
    visualExport?: VisualExportFeaturesDto | undefined;
    userDefinedFields?: UserDefinedFieldsFeaturesDto | undefined;
    extendedDatasets?: ExtendedDatasetsFeaturesDto | undefined;
    pivotStudio?: PivotStudioFeaturesDto | undefined;
    ui?: UIFeaturesDto | undefined;
    dataQuery?: DataQueryFeaturesDto | undefined;
    uI2?: UIFeatures2Dto | undefined;
}

export interface GeneralFeaturesDto {
    enterpriseReporting?: boolean;
    cacheOptionsInVisualListMinRole?: UserRole | undefined;
    organisationSelectMinRole?: UserRole | undefined;
    userImpersonationMinRole?: UserRole | undefined;
    showSessionExpiryPanel?: boolean;
    enableProductUpgradeCheck?: boolean;
}

export interface VisualRenderingFeaturesDto {
}

export interface VisualExportFeaturesDto {
    pivotTableExportMinRole?: UserRole | undefined;
    pngExportMinRole?: UserRole | undefined;
    excelChartImageMinRole?: UserRole | undefined;
    exportLayoutMinRole?: UserRole | undefined;
    showExportDaxQueryMinRole?: UserRole | undefined;
}

export interface UserDefinedFieldsFeaturesDto {
    requestsDisableEmployeeUDFs?: boolean;
}

export interface ExtendedDatasetsFeaturesDto {
    databaseDatasetDefinitions?: boolean;
    allowProfiling?: UserRole | undefined;
}

export interface PivotStudioFeaturesDto {
    allowUserSort?: boolean;
    definitionImportExportMinRole?: UserRole | undefined;
    filterToggleMinRole?: UserRole | undefined;
    collapseAllSectionsMinRole?: UserRole | undefined;
    allowExtendedDatasetRefreshCancellationMinRole?: UserRole | undefined;
    listReturnAllUserVisuals?: boolean;
    visualListRefreshMinRole?: UserRole | undefined;
    reloadVisualMinRole?: UserRole | undefined;
    editOrCopyVisualFromDashboardMinRole?: UserRole | undefined;
    seeErrorDetailsMinRole?: UserRole | undefined;
    newLayout?: boolean | undefined;
}

export interface UIFeaturesDto {
    listViewMultiSelectMinRole?: UserRole | undefined;
    dataHealthSuperAdmin?: boolean;
    dataHealthSupportAdmin?: boolean;
    dataHealthAdmin?: boolean;
    dataHealthBusinessUser?: boolean;
    visualListCaching?: boolean;
    dashboardListCaching?: boolean;
    contentAccessUseImpersonateeRole?: boolean;
}

export interface AppFeaturesSettings {
    overrideDefaults?: boolean;
    features?: AppFeaturesDto | undefined;
}

export interface SetWelcomeDashboardsDto {
    organisationId?: number | undefined;
    dashboardIds?: number[] | undefined;
}

export interface DashboardWelcomeScreensDto {
    dashboardId?: number;
    organisationIds?: (number | undefined)[] | undefined;
}

export interface ListETLStatusDto {
    id?: number;
    organisationId?: number;
    etlType?: ETLType;
    dataSourceVersion?: string | undefined;
    organisationName?: string | undefined;
    region?: string | undefined;
    etlRunId?: number;
    etlRunStatus?: ETLRunStatus;
    runDescription?: string | undefined;
    runStartDate?: string;
    runEndDate?: string | undefined;
}

export interface ExtendedDatasetListItemDto {
    id?: number;
    productVersionId?: number;
    name?: string | undefined;
    displayName?: string | undefined;
    section?: string | undefined;
    createdBy?: UserDto | undefined;
    updatedBy?: UserDto | undefined;
    timeUpdatedUTC?: string;
    enabled?: boolean;
    content?: AdvancedDatasetDto | undefined;
    source?: ExtendedDatasetSource;
}

export enum ExtendedDatasetSource {
    Metadata = 0,
    Json = 1,
}

export interface ExtendedDatasetTemplateDto {
    id?: number;
    productVersionId?: number;
    name?: string | undefined;
    createdBy?: UserDto | undefined;
    updatedBy?: UserDto | undefined;
    timeUpdatedUTC?: string;
    enabled?: boolean;
    content?: AdvancedDatasetDto | undefined;
}

export interface ExtendedDatasetTemplateUpdateRequest {
    content?: AdvancedDatasetDto | undefined;
    enabled?: boolean;
}

export interface ExtendedDatasetDropdownListItemDto {
    id?: number;
    productVersionId?: number;
    name?: string | undefined;
    displayName?: string | undefined;
    type?: DropdownType;
    createdBy?: UserDto | undefined;
    updatedBy?: UserDto | undefined;
    timeUpdatedUTC?: string;
    enabled?: boolean;
    content?: Dropdown | undefined;
    source?: ExtendedDatasetSource;
}

export enum DropdownType {
    Static = 0,
    SqlQuery = 1,
}

export interface Dropdown {
    type?: DropdownType;
    id?: string | undefined;
    displayName?: string | undefined;
    searchable?: boolean;
    requireSearchTerm?: boolean;
    multiselect?: boolean;
    parameterFormatting?: DropdownParameterFormatting;
}

export enum DropdownParameterFormatting {
    Comma = 0,
    Semicolon = 1,
    Pipe = 2,
    RequestsPipe = 3,
}

export interface StaticDropdown extends Dropdown {
    options?: DropdownOptionDto[] | undefined;
}

export interface SqlQueryDropdown extends Dropdown {
    queryFormat?: string | undefined;
    resultType?: SqlQueryDropdownResultType;
    valueField?: string | undefined;
    labelField?: string | undefined;
    fieldDisplayNames?: { [key: string]: string; } | undefined;
    additionalOptions?: DropdownOptionDto[] | undefined;
    autoSelectOnlyOption?: boolean;
}

export enum SqlQueryDropdownResultType {
    Default = 0,
    SemicolonSeparatedList = 1,
}

export interface ExtendedDatasetDropdownDto {
    id?: number;
    productVersionId?: number;
    name?: string | undefined;
    createdBy?: UserDto | undefined;
    updatedBy?: UserDto | undefined;
    timeUpdatedUTC?: string;
    enabled?: boolean;
    content?: Dropdown | undefined;
}

export interface ExtendedDatasetDropdownUpdateRequest {
    content?: Dropdown | undefined;
    enabled?: boolean;
}

export interface FileUploadConfigDto {
    id?: number;
    organisationId?: number;
    name?: string | undefined;
    type?: string | undefined;
    options?: FileUploadOptionsDto | undefined;
}

export interface FileUploadOptionsDto {
    type?: FileUploadOptionsType;
    credential?: FileUploadCredentialDto | undefined;
}

export enum FileUploadOptionsType {
    Simple = 0,
}

export interface FileUploadCredentialDto {
    type?: FileUploadCredentialType;
}

export enum FileUploadCredentialType {
    None = 0,
    Basic = 1,
}

export interface FileUploadBasicCredentialDto extends FileUploadCredentialDto {
    username?: string | undefined;
    password?: string | undefined;
}

export interface SimpleFileUploadOptionsDto extends FileUploadOptionsDto {
    host?: string | undefined;
    port?: number;
    basePath?: string | undefined;
    conflictBehaviour?: FileUploadConflictBehaviour;
}

export interface AddOrUpdateFileUploadConfigDto {
    organisationId?: number;
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    options?: FileUploadOptionsDto | undefined;
}

export interface FileUploadVerifyConnectionResultDto {
    success?: boolean;
    error?: string | undefined;
}

export interface GainsightPXSettings {
    enabled?: boolean;
    trackBusinessUsers?: boolean;
    trackAdmins?: boolean;
    trackSupportAdmins?: boolean;
    trackSuperAdmins?: boolean;
    tagName?: string | undefined;
    includePII?: PIIMode;
    scriptTemplate?: string | undefined;
    userIdServiceUrl?: string | undefined;
    userIdServiceApiKey?: string | undefined;
    userIdServiceApiKeyHeaderName?: string | undefined;
}

export enum PIIMode {
    Include = 0,
    Exclude = 1,
    IncludeObfuscated = 2,
}

export interface JobInfoDto {
    jobId?: number;
    orgId?: number | undefined;
    orgName?: string | undefined;
    typeName?: string | undefined;
    disabled?: boolean;
    status?: JobStatus;
    scheduledTime?: string;
    startedTime?: string | undefined;
    finishedTime?: string | undefined;
    recurring?: boolean;
    cronExpression?: string | undefined;
    nextRun?: string | undefined;
    scheduledBy?: string | undefined;
}

export interface JobInfoQueryDto {
    jobIds?: (number | undefined)[] | undefined;
    orgIds?: (number | undefined)[] | undefined;
    typeNames?: string[] | undefined;
    scheduledRange?: JobInfoDateRange | undefined;
    startedRange?: JobInfoDateRange | undefined;
    finishedRange?: JobInfoDateRange | undefined;
    disabled?: boolean | undefined;
    statuses?: JobStatus[] | undefined;
    recurring?: boolean | undefined;
    nextRunOnRange?: JobInfoDateRange | undefined;
    scheduledBy?: string[] | undefined;
    sortBy?: JobInfoSortBy;
    maxResults?: number;
}

export interface JobInfoDateRange {
    start?: string | undefined;
    end?: string | undefined;
}

export enum JobInfoSortBy {
    ScheduleAsc = 0,
    ScheduleDesc = 1,
    StartAsc = 2,
    StartDesc = 3,
    FinishedAsc = 4,
    FinishedDesc = 5,
    NextRunAsc = 6,
    NextRunDesc = 7,
}

export interface GetTrackedJobInfoResultDto {
    uptoDateJobs?: JobInfoDto[] | undefined;
    newUntrackedJobsCount?: number;
}

export interface GetTrackedJobInfoRequestDto {
    currentQuery?: JobInfoQueryDto | undefined;
    currentlyTrackedJobIds?: number[] | undefined;
}

export interface JobModificationDto {
    scheduleTime?: string;
    serializedData?: string | undefined;
    cronExpression?: string | undefined;
    recurring?: boolean;
}

export interface OrganisationDto extends ListOrganisationDto {
    clientCustomizationSettings?: ClientCustomizationSettingsDto | undefined;
    displayName?: string | undefined;
}

export interface AddOrUpdateOrganisationDto {
    id?: number;
    name?: string | undefined;
    longName?: string | undefined;
    defaults?: AppSettingsDto | undefined;
    products?: OrganisationProductDto[] | undefined;
}

export interface JobStateDto {
    jobId?: number;
    type?: string | undefined;
    status?: JobStatus;
    executor?: string | undefined;
    progress?: number | undefined;
    estimatedCompletionTime?: string | undefined;
    startedDate?: string | undefined;
    finishedDate?: string | undefined;
    error?: string | undefined;
    disabled?: boolean;
    cancelled?: boolean;
}

export interface GetLastJobIdDto {
    organisationId?: number;
    runningJobState?: JobStateDto | undefined;
    completedJobState?: JobStateDto | undefined;
}

export interface SendTestEmailRequestDto {
    configuration?: EmailSenderConfigurationDto | undefined;
    to?: string | undefined;
}

export interface EmailSenderConfigurationDto {
    senderType: EmailSenderType;
    from?: EmailSenderFromOptions;
}

export enum EmailSenderType {
    Shared = 0,
    SMTP = 1,
    SendGrid = 2,
}

export interface EmailSenderFromOptions {
    address?: string | undefined;
    title?: string | undefined;
}

export interface SharedEmailSenderConfigurationDto extends EmailSenderConfigurationDto {
}

export interface SendGridEmailSenderConfigurationDto extends EmailSenderConfigurationDto {
    apiKey?: string | undefined;
}

export interface SMTPEmailSenderConfigurationDto extends EmailSenderConfigurationDto {
    hostname?: string | undefined;
    port?: number | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export interface DataModelRefreshLog {
    timestamp?: string;
    triggeredBy?: string | undefined;
    reason?: string | undefined;
    detail?: DataModelRefreshLogDetail | undefined;
}

export interface DataModelRefreshLogDetail {
    products?: string[] | undefined;
    spend?: SpendDetail | undefined;
    monitor?: MonitorDetail | undefined;
    requests?: QuestDetail | undefined;
    combined?: CombinedDetail | undefined;
    error?: string | undefined;
}

export interface SpendDetail {
    enabled?: boolean;
    version?: string | undefined;
    activeCurrencies?: string | undefined;
    currencies?: string[] | undefined;
    projectCodeAllocEnabled?: boolean;
    anyUDFs?: boolean;
}

export interface MonitorDetail {
    enabled?: boolean;
    version?: string | undefined;
}

export interface QuestDetail {
    enabled?: boolean;
    version?: string | undefined;
    anyUDFs?: boolean;
}

export interface CombinedDetail {
    enabled?: boolean;
    version?: string | undefined;
}

export interface OrganisationProductConnectionDetails {
    product?: string | undefined;
    server?: string | undefined;
    database?: string | undefined;
}

export interface ProductSourceExecuteSqlResponse {
    messages?: SqlMessage[] | undefined;
    affectedRows?: number;
    columns?: Column[] | undefined;
    rows?: any[][] | undefined;
}

export interface SqlMessage {
    source?: string | undefined;
    message?: string | undefined;
    errors?: SqlError[] | undefined;
}

export interface SqlError {
    source?: string | undefined;
    number?: number;
    state?: number;
    class?: number;
    server?: string | undefined;
    message?: string | undefined;
    procedure?: string | undefined;
    lineNumber?: number;
}

export interface Column {
    name?: string | undefined;
    type?: string | undefined;
}

export interface ProductSourceExecuteSqlRequest {
    productName?: string | undefined;
    sql?: string | undefined;
    parameters?: Parameter[] | undefined;
    expectResultSet?: boolean;
    timeout?: number | undefined;
    rowLimit?: number;
}

export interface Parameter {
    name?: string | undefined;
    dataType?: ValueDataType;
    value?: any | undefined;
}

export interface RecurringValidateDataModelsOptionsDto {
    enabled?: boolean;
    expression?: string | undefined;
    timeZone?: string | undefined;
}

export interface SpendMonitorMashupStateDto {
    state?: SpendMonitorMashupProcessState;
    startTimestamp?: string | undefined;
    endTimestamp?: string | undefined;
    duration?: string;
    durationText?: string | undefined;
    error?: ErrorDetails | undefined;
    steps?: { [key: string]: SpendMonitorMashupStepDto; } | undefined;
}

export enum SpendMonitorMashupProcessState {
    Running = 0,
    Success = 1,
    Failure = 2,
}

export interface SpendMonitorMashupStepDto {
    state?: SpendMonitorMashupProcessState;
    startTimestamp?: string;
    endTimestamp?: string | undefined;
    duration?: string;
    durationText?: string | undefined;
    error?: ErrorDetails | undefined;
}

export interface ListOrganisationSecretDto {
    name?: string | undefined;
    value?: string | undefined;
    hasValue?: boolean;
}

export interface AddOrUpdateOrganisationSecretDto {
    organisationId?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export interface ListProductDto {
    id?: number;
    name?: string | undefined;
    versions?: ListProductVersionDto[] | undefined;
}

export interface ProductDto {
    id?: number;
    createdDate?: string;
    updatedDate?: string;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    name?: string | undefined;
    itemCategories?: ProductItemCategoryDto[] | undefined;
}

export interface ProductItemCategoryDto {
    id?: number;
    name?: string | undefined;
}

export interface AddOrUpdateProductDto {
    id?: number;
    name?: string | undefined;
    itemCategories?: ProductItemCategoryDto[] | undefined;
}

export interface ListProductUpgradeDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    currentVersionId?: number | undefined;
    targetVersionId?: number | undefined;
    createdDate?: string;
    stale?: boolean;
}

export interface AvailableUpgradeDto {
    id?: number;
    organisationId?: number;
    organisationName?: string | undefined;
    productId?: number;
    productName?: string | undefined;
    status?: number;
    currentVersionId?: number | undefined;
    currentVersion?: string | undefined;
    targetVersionId?: number | undefined;
    targetVersion?: string | undefined;
    createdDate?: string;
    stale?: boolean;
    description?: string | undefined;
}

export interface ProductVersionDto {
    productId?: number;
    productName?: string | undefined;
    id?: number;
    name?: string | undefined;
    pbiSemanticModelId?: PbiDatasetId | undefined;
}

export interface PbiDatasetId {
    workspaceGuid?: string;
    datasetId?: string | undefined;
}

export interface AddOrUpdateProductVersionDto {
    productId?: number;
    id?: number;
    name?: string | undefined;
    pbiSemanticModelId?: PbiDatasetId | undefined;
}

export interface SiteContentDto {
    type?: SiteContentType;
    content?: string | undefined;
}

export enum SiteContentType {
    SupportLinks = 0,
}

export interface SpendDuplicateImportErrorDto {
    newNameSuffix?: string | undefined;
}

export interface ImportVisualsResultDto {
    results?: ImportVisualResultDto[] | undefined;
}

export interface SpendPivotStudioMappingsDto {
    mappings?: SpendPivotStudioMappingDto[] | undefined;
}

export interface SpendPivotStudioMappingDto {
    expression?: string | undefined;
    childPropertyName?: string | undefined;
    targetSchemaName?: string | undefined;
    targetGroupName?: string | undefined;
    targetFieldName?: string | undefined;
    flags?: SpendMappingFlags;
}

export enum SpendMappingFlags {
    None = 0,
    Year = 1,
    Month = 2,
}

export interface SetUserRoleDto {
    userId?: number;
    role?: UserRole;
}

export interface GainsightUserSettings {
    enabled?: boolean;
    tagScript?: string | undefined;
    userId?: string | undefined;
    includePII?: PIIMode;
}

export interface DatasetRefreshErrorDto {
    dataset?: string | undefined;
    error?: string | undefined;
    detail?: string | undefined;
    userFriendly?: boolean;
}

export enum ImportVisualDuplicateHandling {
    Throw = "Throw",
    Copy = "Copy",
    Override = "Override",
}

export interface CanvasRendererContentLoadOptions {
    contentType?: CanvasRendererContentType;
    organisationId?: number | undefined;
    userId?: number | undefined;
    userData?: EnterpriseUserDataDto | undefined;
    renderUnshared?: boolean;
}

export enum CanvasRendererContentType {
    Visual = 0,
    Dashboard = 1,
}

export interface CanvasRendererLoadVisualOptions extends CanvasRendererContentLoadOptions {
    visualId?: number;
    visual?: VisualDto | undefined;
}

export interface CanvasRendererLoadDashboardOptions extends CanvasRendererContentLoadOptions {
    dashboardId?: number;
    dashboard?: DashboardDto | undefined;
    visualContents?: DashboardVisualContentDto[] | undefined;
}

export interface GeneratePdfOptions {
    scale?: number;
    landscape?: boolean | undefined;
    pageRanges?: PageRange[] | undefined;
    transparentBackground?: boolean;
    paperSize?: PdfPaperSize;
}

export interface PageRange {
    from?: number;
    to?: number;
}

export interface GenerateImageOptions {
    clipRect?: RectangleF | undefined;
    fullPage?: boolean;
    transparentBackground?: boolean;
    imageFormat?: GenerateImageFormat;
    quality?: number;
}

export interface RectangleF {
    location?: PointF;
    size?: string;
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
    isEmpty?: boolean;
}

export interface PointF {
    isEmpty?: boolean;
    x?: number;
    y?: number;
}

export enum GenerateImageFormat {
    Jpeg = 0,
    Png = 1,
}

export interface CanvasRendererBrandingOptions {
    includeHeader?: boolean;
    includeFooter?: boolean;
    orgName?: string | undefined;
    headerLogoUrl?: string | undefined;
    namePrefix?: string | undefined;
    name?: string | undefined;
    showPageNumbers?: boolean;
    exportedAtUTC?: string;
    exportedAtTimeZone?: string | undefined;
    exportedAtLocal?: string | undefined;
}

export interface CanvasRendererRenderParams {
    renderType?: string | undefined;
    paperSize?: PdfPaperSize;
    landscape?: boolean;
    pageCount?: number;
    size?: CanvasRendererRenderSize | undefined;
    scale?: number;
    locale?: string | undefined;
}

export interface CanvasRendererRenderSize {
    width?: number;
    height?: number;
}

export interface CanvasRendererHostCallResult {
    success?: boolean;
    error?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}